export default {
 "triangles": [
  [
   {
    "x": 110.18518320719404,
    "y": 53.666666666666686
   },
   {
    "x": 110.18518320719404,
    "y": 47.05555555555557
   },
   {
    "x": 104.7407387627496,
    "y": 47.44444444444446
   }
  ],
  [
   {
    "x": 105.51851654052737,
    "y": 53.27777777777779
   },
   {
    "x": 110.57407209608293,
    "y": 49.000000000000014
   },
   {
    "x": 103.96296098497182,
    "y": 48.222222222222236
   }
  ],
  [
   {
    "x": 99.68518320719404,
    "y": 53.27777777777779
   },
   {
    "x": 108.2407387627496,
    "y": 48.222222222222236
   },
   {
    "x": 97.7407387627496,
    "y": 47.83333333333335
   }
  ],
  [
   {
    "x": 93.8518498738607,
    "y": 55.61111111111113
   },
   {
    "x": 102.40740542941626,
    "y": 47.05555555555557
   },
   {
    "x": 91.12962765163849,
    "y": 46.66666666666668
   }
  ],
  [
   {
    "x": 112.51851654052737,
    "y": 48.61111111111113
   },
   {
    "x": 107.46296098497182,
    "y": 42.77777777777779
   },
   {
    "x": 105.90740542941626,
    "y": 49.38888888888891
   }
  ],
  [
   {
    "x": 111.7407387627496,
    "y": 45.11111111111112
   },
   {
    "x": 106.29629431830516,
    "y": 39.27777777777779
   },
   {
    "x": 103.57407209608293,
    "y": 45.500000000000014
   }
  ],
  [
   {
    "x": 110.18518320719404,
    "y": 40.055555555555564
   },
   {
    "x": 103.96296098497182,
    "y": 35.3888888888889
   },
   {
    "x": 103.57407209608293,
    "y": 42.3888888888889
   }
  ],
  [
   {
    "x": 110.18518320719404,
    "y": 32.277777777777786
   },
   {
    "x": 99.68518320719404,
    "y": 35.777777777777786
   },
   {
    "x": 102.40740542941626,
    "y": 40.055555555555564
   }
  ],
  [
   {
    "x": 109.79629431830516,
    "y": 28.777777777777786
   },
   {
    "x": 92.68518320719404,
    "y": 36.94444444444446
   },
   {
    "x": 97.3518498738607,
    "y": 40.055555555555564
   }
  ],
  [
   {
    "x": 99.68518320719404,
    "y": 32.277777777777786
   },
   {
    "x": 91.51851654052737,
    "y": 41.222222222222236
   },
   {
    "x": 95.79629431830514,
    "y": 43.16666666666668
   }
  ],
  [
   {
    "x": 88.40740542941626,
    "y": 57.166666666666686
   },
   {
    "x": 97.3518498738607,
    "y": 49.77777777777779
   },
   {
    "x": 86.07407209608293,
    "y": 52.88888888888891
   }
  ],
  [
   {
    "x": 83.3518498738607,
    "y": 59.50000000000002
   },
   {
    "x": 92.29629431830514,
    "y": 51.33333333333335
   },
   {
    "x": 79.07407209608293,
    "y": 53.27777777777779
   }
  ],
  [
   {
    "x": 78.68518320719403,
    "y": 63.00000000000002
   },
   {
    "x": 88.01851654052737,
    "y": 51.33333333333335
   },
   {
    "x": 74.01851654052737,
    "y": 57.944444444444464
   }
  ],
  [
   {
    "x": 75.18518320719403,
    "y": 66.11111111111113
   },
   {
    "x": 80.62962765163847,
    "y": 55.222222222222236
   },
   {
    "x": 70.51851654052736,
    "y": 61.83333333333335
   }
  ],
  [
   {
    "x": 71.29629431830514,
    "y": 68.44444444444447
   },
   {
    "x": 75.96296098497182,
    "y": 58.33333333333335
   },
   {
    "x": 68.57407209608292,
    "y": 63.7777777777778
   }
  ],
  [
   {
    "x": 68.96296098497182,
    "y": 72.72222222222224
   },
   {
    "x": 71.29629431830514,
    "y": 61.83333333333335
   },
   {
    "x": 63.90740542941625,
    "y": 69.61111111111113
   }
  ],
  [
   {
    "x": 66.24073876274959,
    "y": 76.61111111111113
   },
   {
    "x": 66.24073876274959,
    "y": 65.72222222222224
   },
   {
    "x": 61.96296098497181,
    "y": 75.83333333333336
   }
  ],
  [
   {
    "x": 65.8518498738607,
    "y": 81.2777777777778
   },
   {
    "x": 62.74073876274959,
    "y": 71.16666666666669
   },
   {
    "x": 61.96296098497181,
    "y": 82.83333333333336
   }
  ],
  [
   {
    "x": 98.90740542941626,
    "y": 29.166666666666675
   },
   {
    "x": 87.62962765163849,
    "y": 39.27777777777779
   },
   {
    "x": 93.8518498738607,
    "y": 42.3888888888889
   }
  ],
  [
   {
    "x": 96.18518320719404,
    "y": 28.000000000000007
   },
   {
    "x": 81.40740542941626,
    "y": 43.16666666666668
   },
   {
    "x": 86.46296098497182,
    "y": 43.94444444444446
   }
  ],
  [
   {
    "x": 88.01851654052737,
    "y": 33.83333333333334
   },
   {
    "x": 80.62962765163847,
    "y": 44.722222222222236
   },
   {
    "x": 86.07407209608293,
    "y": 45.11111111111112
   }
  ],
  [
   {
    "x": 87.24073876274959,
    "y": 30.722222222222232
   },
   {
    "x": 76.3518498738607,
    "y": 46.66666666666668
   },
   {
    "x": 83.74073876274959,
    "y": 45.8888888888889
   }
  ],
  [
   {
    "x": 81.79629431830514,
    "y": 34.61111111111112
   },
   {
    "x": 74.40740542941626,
    "y": 49.77777777777779
   },
   {
    "x": 80.62962765163847,
    "y": 48.61111111111113
   }
  ],
  [
   {
    "x": 81.01851654052737,
    "y": 31.50000000000001
   },
   {
    "x": 70.90740542941626,
    "y": 51.722222222222236
   },
   {
    "x": 79.07407209608293,
    "y": 47.44444444444446
   }
  ],
  [
   {
    "x": 72.07407209608292,
    "y": 43.16666666666668
   },
   {
    "x": 64.68518320719403,
    "y": 56.77777777777779
   },
   {
    "x": 76.3518498738607,
    "y": 50.16666666666668
   }
  ],
  [
   {
    "x": 65.8518498738607,
    "y": 48.61111111111113
   },
   {
    "x": 61.96296098497181,
    "y": 60.666666666666686
   },
   {
    "x": 72.46296098497182,
    "y": 53.666666666666686
   }
  ],
  [
   {
    "x": 61.574072096082915,
    "y": 52.88888888888891
   },
   {
    "x": 59.24073876274959,
    "y": 65.33333333333336
   },
   {
    "x": 67.79629431830514,
    "y": 56.77777777777779
   }
  ],
  [
   {
    "x": 56.90740542941625,
    "y": 58.33333333333335
   },
   {
    "x": 56.90740542941625,
    "y": 70.38888888888891
   },
   {
    "x": 64.68518320719403,
    "y": 61.444444444444464
   }
  ],
  [
   {
    "x": 53.40740542941625,
    "y": 66.88888888888891
   },
   {
    "x": 56.12962765163847,
    "y": 80.11111111111113
   },
   {
    "x": 61.574072096082915,
    "y": 68.05555555555557
   }
  ],
  [
   {
    "x": 52.88888888888891,
    "y": 77.25926123725046
   },
   {
    "x": 57.944444444444464,
    "y": 83.48148345947268
   },
   {
    "x": 59.11111111111113,
    "y": 74.53703901502823
   }
  ],
  [
   {
    "x": 53.666666666666686,
    "y": 81.14815012613934
   },
   {
    "x": 60.27777777777779,
    "y": 88.14815012613936
   },
   {
    "x": 57.944444444444464,
    "y": 77.64815012613934
   }
  ],
  [
   {
    "x": 56.000000000000014,
    "y": 86.2037056816949
   },
   {
    "x": 64.94444444444446,
    "y": 92.42592790391713
   },
   {
    "x": 60.27777777777779,
    "y": 83.87037234836157
   }
  ],
  [
   {
    "x": 56.77777777777779,
    "y": 89.7037056816949
   },
   {
    "x": 71.55555555555557,
    "y": 99.81481679280601
   },
   {
    "x": 61.83333333333335,
    "y": 86.2037056816949
   }
  ],
  [
   {
    "x": 106.55555555555559,
    "y": 126.25926123725047
   },
   {
    "x": 100.72222222222226,
    "y": 118.4814834594727
   },
   {
    "x": 106.55555555555559,
    "y": 122.75926123725047
   }
  ],
  [
   {
    "x": 110.83333333333337,
    "y": 132.0925945705838
   },
   {
    "x": 104.61111111111114,
    "y": 120.03703901502824
   },
   {
    "x": 114.33333333333337,
    "y": 130.92592790391714
   }
  ],
  [
   {
    "x": 114.46296098497183,
    "y": 140.25926123725048
   },
   {
    "x": 112.12962765163849,
    "y": 130.14815012613937
   },
   {
    "x": 116.79629431830516,
    "y": 139.48148345947268
   }
  ],
  [
   {
    "x": 110.18518320719404,
    "y": 146.8703723483616
   },
   {
    "x": 114.85184987386071,
    "y": 135.2037056816949
   },
   {
    "x": 116.79629431830516,
    "y": 143.3703723483616
   }
  ],
  [
   {
    "x": 107.07407209608293,
    "y": 151.53703901502826
   },
   {
    "x": 117.18518320719404,
    "y": 141.42592790391714
   },
   {
    "x": 114.46296098497183,
    "y": 150.75926123725048
   }
  ],
  [
   {
    "x": 103.57407209608293,
    "y": 156.59259457058383
   },
   {
    "x": 116.79629431830516,
    "y": 146.0925945705838
   },
   {
    "x": 111.35184987386071,
    "y": 158.14815012613937
   }
  ],
  [
   {
    "x": 97.0925945705838,
    "y": 163.20370568169494
   },
   {
    "x": 111.0925945705838,
    "y": 153.8703723483616
   },
   {
    "x": 104.0925945705838,
    "y": 164.3703723483616
   }
  ],
  [
   {
    "x": 90.0925945705838,
    "y": 167.09259457058383
   },
   {
    "x": 107.5925945705838,
    "y": 160.8703723483616
   },
   {
    "x": 93.98148345947268,
    "y": 172.92592790391714
   }
  ],
  [
   {
    "x": 84.7777777777778,
    "y": 169.81482272677957
   },
   {
    "x": 98.77777777777781,
    "y": 169.42593383789068
   },
   {
    "x": 87.50000000000003,
    "y": 176.81482272677957
   }
  ],
  [
   {
    "x": 77.00000000000003,
    "y": 173.70371161566845
   },
   {
    "x": 94.50000000000003,
    "y": 173.70371161566845
   },
   {
    "x": 81.66666666666669,
    "y": 179.1481560601129
   }
  ],
  [
   {
    "x": 69.22222222222224,
    "y": 176.81482272677957
   },
   {
    "x": 86.72222222222224,
    "y": 175.6481560601129
   },
   {
    "x": 70.38888888888891,
    "y": 181.8703782823351
   }
  ],
  [
   {
    "x": 59.88888888888891,
    "y": 177.98148939344622
   },
   {
    "x": 77.7777777777778,
    "y": 179.92593383789068
   },
   {
    "x": 60.666666666666686,
    "y": 183.42593383789068
   }
  ],
  [
   {
    "x": 53.27777777777779,
    "y": 177.98148939344622
   },
   {
    "x": 67.66666666666669,
    "y": 183.81482272677957
   },
   {
    "x": 52.500000000000014,
    "y": 182.6481560601129
   }
  ],
  [
   {
    "x": 47.05555555555557,
    "y": 176.81482272677957
   },
   {
    "x": 58.33333333333335,
    "y": 184.98148939344622
   },
   {
    "x": 45.11111111111112,
    "y": 181.09260050455734
   }
  ],
  [
   {
    "x": 40.83333333333334,
    "y": 172.1481560601129
   },
   {
    "x": 50.94444444444446,
    "y": 184.20371161566845
   },
   {
    "x": 35.777777777777786,
    "y": 174.09260050455734
   }
  ],
  [
   {
    "x": 117.70370568169491,
    "y": 163.46295505099832
   },
   {
    "x": 120.03703901502824,
    "y": 152.96295505099832
   },
   {
    "x": 113.42592790391714,
    "y": 160.7407328287761
   }
  ],
  [
   {
    "x": 113.03703901502824,
    "y": 170.07406616210943
   },
   {
    "x": 117.70370568169491,
    "y": 156.8518439398872
   },
   {
    "x": 108.75926123725047,
    "y": 165.40739949544275
   }
  ],
  [
   {
    "x": 107.20370568169491,
    "y": 175.90739949544277
   },
   {
    "x": 113.81481679280603,
    "y": 163.46295505099832
   },
   {
    "x": 102.14815012613936,
    "y": 172.40739949544275
   }
  ],
  [
   {
    "x": 100.98148345947268,
    "y": 181.7407328287761
   },
   {
    "x": 108.75926123725047,
    "y": 167.3518439398872
   },
   {
    "x": 98.25926123725047,
    "y": 177.07406616210943
   }
  ],
  [
   {
    "x": 93.5925945705838,
    "y": 186.79628838433166
   },
   {
    "x": 102.92592790391713,
    "y": 174.3518439398872
   },
   {
    "x": 91.64815012613936,
    "y": 180.96295505099832
   }
  ],
  [
   {
    "x": 85.81481679280601,
    "y": 189.12962171766497
   },
   {
    "x": 96.31481679280601,
    "y": 179.40739949544277
   },
   {
    "x": 83.0925945705838,
    "y": 186.0185106065539
   }
  ],
  [
   {
    "x": 83.0925945705838,
    "y": 193.0185106065539
   },
   {
    "x": 85.81481679280601,
    "y": 182.90739949544277
   },
   {
    "x": 79.98148345947268,
    "y": 186.79628838433166
   }
  ],
  [
   {
    "x": 80.37037234836157,
    "y": 195.7407328287761
   },
   {
    "x": 82.31481679280601,
    "y": 184.8518439398872
   },
   {
    "x": 76.87037234836157,
    "y": 187.18517727322055
   }
  ],
  [
   {
    "x": 78.42592790391713,
    "y": 196.5185106065539
   },
   {
    "x": 78.03703901502824,
    "y": 185.62962171766497
   },
   {
    "x": 72.98148345947268,
    "y": 189.12962171766497
   }
  ],
  [
   {
    "x": 76.87037234836157,
    "y": 199.2407328287761
   },
   {
    "x": 78.03703901502824,
    "y": 186.79628838433166
   },
   {
    "x": 73.75926123725046,
    "y": 187.18517727322055
   }
  ],
  [
   {
    "x": 71.81481679280601,
    "y": 199.629621717665
   },
   {
    "x": 76.09259457058378,
    "y": 186.40739949544277
   },
   {
    "x": 70.25926123725046,
    "y": 187.18517727322055
   }
  ],
  [
   {
    "x": 64.42592790391711,
    "y": 202.3518439398872
   },
   {
    "x": 76.09259457058378,
    "y": 189.90739949544277
   },
   {
    "x": 70.25926123725046,
    "y": 189.5185106065539
   }
  ],
  [
   {
    "x": 62.87037234836156,
    "y": 199.629621717665
   },
   {
    "x": 70.64815012613934,
    "y": 190.68517727322055
   },
   {
    "x": 67.53703901502823,
    "y": 190.29628838433166
   }
  ],
  [
   {
    "x": 58.98148345947268,
    "y": 201.18517727322055
   },
   {
    "x": 71.03703901502823,
    "y": 191.07406616210943
   },
   {
    "x": 62.48148345947268,
    "y": 190.68517727322055
   }
  ],
  [
   {
    "x": 58.2037056816949,
    "y": 197.68517727322055
   },
   {
    "x": 66.75926123725046,
    "y": 190.29628838433166
   },
   {
    "x": 61.314816792806006,
    "y": 190.29628838433166
   }
  ],
  [
   {
    "x": 44.20370568169489,
    "y": 199.2407328287761
   },
   {
    "x": 65.2037056816949,
    "y": 195.3518439398872
   },
   {
    "x": 62.48148345947268,
    "y": 192.2407328287761
   }
  ],
  [
   {
    "x": 35.25926123725044,
    "y": 197.68517727322055
   },
   {
    "x": 62.48148345947268,
    "y": 194.18517727322055
   },
   {
    "x": 57.814816792806006,
    "y": 190.68517727322055
   }
  ],
  [
   {
    "x": 34.09259457058378,
    "y": 193.79628838433166
   },
   {
    "x": 54.70370568169489,
    "y": 192.62962171766497
   },
   {
    "x": 53.53703901502823,
    "y": 190.68517727322055
   }
  ],
  [
   {
    "x": 27.481483459472663,
    "y": 193.40739949544277
   },
   {
    "x": 53.53703901502823,
    "y": 192.2407328287761
   },
   {
    "x": 51.592594570583785,
    "y": 189.90739949544277
   }
  ],
  [
   {
    "x": 26.703705681694885,
    "y": 189.90739949544277
   },
   {
    "x": 48.87037234836156,
    "y": 190.29628838433166
   },
   {
    "x": 46.148150126139335,
    "y": 187.57406616210943
   }
  ],
  [
   {
    "x": 22.425927903917106,
    "y": 187.96295505099832
   },
   {
    "x": 48.48148345947267,
    "y": 189.5185106065539
   },
   {
    "x": 44.98148345947267,
    "y": 187.18517727322055
   }
  ],
  [
   {
    "x": 19.703705681694885,
    "y": 184.07406616210943
   },
   {
    "x": 40.314816792806,
    "y": 187.57406616210943
   },
   {
    "x": 34.870372348361556,
    "y": 182.12962171766497
   }
  ],
  [
   {
    "x": 18.148150126139328,
    "y": 180.57406616210943
   },
   {
    "x": 35.25926123725044,
    "y": 183.29628838433166
   },
   {
    "x": 33.314816792806,
    "y": 179.01851060655386
   }
  ],
  [
   {
    "x": 23.981483459472663,
    "y": 178.2407328287761
   },
   {
    "x": 30.20370568169489,
    "y": 181.7407328287761
   },
   {
    "x": 30.981483459472667,
    "y": 178.2407328287761
   }
  ],
  [
   {
    "x": 22.814816792805996,
    "y": 174.7407328287761
   },
   {
    "x": 29.03703901502822,
    "y": 177.8518439398872
   },
   {
    "x": 29.03703901502822,
    "y": 175.51851060655386
   }
  ],
  [
   {
    "x": 20.092594570583774,
    "y": 170.07406616210943
   },
   {
    "x": 27.481483459472663,
    "y": 179.40739949544277
   },
   {
    "x": 27.092594570583774,
    "y": 172.40739949544275
   }
  ],
  [
   {
    "x": 18.925927903917106,
    "y": 166.57406616210943
   },
   {
    "x": 27.870372348361553,
    "y": 175.90739949544277
   },
   {
    "x": 29.03703901502822,
    "y": 168.90739949544275
   }
  ],
  [
   {
    "x": 21.259261237250442,
    "y": 165.40739949544275
   },
   {
    "x": 27.092594570583774,
    "y": 174.3518439398872
   },
   {
    "x": 29.03703901502822,
    "y": 172.40739949544275
   }
  ],
  [
   {
    "x": 20.481483459472663,
    "y": 162.29628838433163
   },
   {
    "x": 27.481483459472663,
    "y": 172.79628838433166
   },
   {
    "x": 29.814816792806,
    "y": 169.29628838433166
   }
  ],
  [
   {
    "x": 23.592594570583774,
    "y": 161.90739949544275
   },
   {
    "x": 26.703705681694885,
    "y": 168.12962171766497
   },
   {
    "x": 28.64815012613933,
    "y": 161.51851060655386
   }
  ],
  [
   {
    "x": 23.203705681694885,
    "y": 153.7407328287761
   },
   {
    "x": 27.870372348361553,
    "y": 166.96295505099832
   },
   {
    "x": 29.42592790391711,
    "y": 154.12962171766497
   }
  ],
  [
   {
    "x": 25.53703901502822,
    "y": 146.7407328287761
   },
   {
    "x": 26.703705681694885,
    "y": 160.3518439398872
   },
   {
    "x": 30.981483459472667,
    "y": 147.51851060655386
   }
  ],
  [
   {
    "x": 28.259261237250442,
    "y": 139.7407328287761
   },
   {
    "x": 28.259261237250442,
    "y": 150.62962171766497
   },
   {
    "x": 33.314816792806,
    "y": 142.46295505099832
   }
  ],
  [
   {
    "x": 30.981483459472667,
    "y": 135.46295505099832
   },
   {
    "x": 30.981483459472667,
    "y": 144.40739949544275
   },
   {
    "x": 35.648150126139335,
    "y": 137.79628838433163
   }
  ],
  [
   {
    "x": 34.870372348361556,
    "y": 130.01851060655386
   },
   {
    "x": 34.09259457058378,
    "y": 139.7407328287761
   },
   {
    "x": 39.92592790391711,
    "y": 133.51851060655386
   }
  ],
  [
   {
    "x": 40.314816792806,
    "y": 126.51851060655386
   },
   {
    "x": 36.814816792806,
    "y": 135.46295505099832
   },
   {
    "x": 44.20370568169489,
    "y": 128.0740661621094
   }
  ],
  [
   {
    "x": 42.648150126139335,
    "y": 122.50000000000004
   },
   {
    "x": 41.870372348361556,
    "y": 129.8888888888889
   },
   {
    "x": 45.370372348361556,
    "y": 124.0555555555556
   }
  ],
  [
   {
    "x": 45.370372348361556,
    "y": 120.94444444444449
   },
   {
    "x": 44.20370568169489,
    "y": 124.44444444444449
   },
   {
    "x": 47.314816792806006,
    "y": 121.72222222222226
   }
  ],
  [
   {
    "x": 44.98148345947267,
    "y": 113.1666666666667
   },
   {
    "x": 47.314816792806006,
    "y": 123.6666666666667
   },
   {
    "x": 51.20370568169489,
    "y": 120.55555555555559
   }
  ],
  [
   {
    "x": 53.92592790391712,
    "y": 108.11111111111114
   },
   {
    "x": 47.70370568169489,
    "y": 122.88888888888893
   },
   {
    "x": 57.814816792806006,
    "y": 113.1666666666667
   }
  ],
  [
   {
    "x": 58.98148345947268,
    "y": 105.38888888888891
   },
   {
    "x": 52.37037234836156,
    "y": 119.00000000000004
   },
   {
    "x": 62.092594570583785,
    "y": 111.22222222222226
   }
  ],
  [
   {
    "x": 63.38888888888891,
    "y": 102.53703901502824
   },
   {
    "x": 56.38888888888891,
    "y": 113.42592790391714
   },
   {
    "x": 65.33333333333336,
    "y": 108.37037234836158
   }
  ],
  [
   {
    "x": 67.2777777777778,
    "y": 99.03703901502824
   },
   {
    "x": 61.05555555555557,
    "y": 112.25926123725047
   },
   {
    "x": 70.38888888888891,
    "y": 104.48148345947268
   }
  ],
  [
   {
    "x": 90.22222222222224,
    "y": 88.14815012613936
   },
   {
    "x": 82.83333333333336,
    "y": 94.75926123725046
   },
   {
    "x": 90.22222222222224,
    "y": 93.5925945705838
   }
  ],
  [
   {
    "x": 97.61111111111114,
    "y": 84.64815012613934
   },
   {
    "x": 86.33333333333336,
    "y": 93.98148345947268
   },
   {
    "x": 99.94444444444447,
    "y": 88.53703901502824
   }
  ],
  [
   {
    "x": 105.38888888888891,
    "y": 80.50000000000003
   },
   {
    "x": 94.50000000000003,
    "y": 91.38888888888891
   },
   {
    "x": 108.50000000000003,
    "y": 84.7777777777778
   }
  ],
  [
   {
    "x": 113.94444444444449,
    "y": 78.16666666666669
   },
   {
    "x": 101.88888888888891,
    "y": 86.33333333333336
   },
   {
    "x": 108.88888888888893,
    "y": 86.33333333333336
   }
  ],
  [
   {
    "x": 122.88888888888893,
    "y": 76.22222222222224
   },
   {
    "x": 111.22222222222226,
    "y": 83.61111111111114
   },
   {
    "x": 119.77777777777781,
    "y": 81.66666666666669
   }
  ],
  [
   {
    "x": 128.72222222222226,
    "y": 73.88888888888891
   },
   {
    "x": 116.6666666666667,
    "y": 82.05555555555559
   },
   {
    "x": 120.94444444444449,
    "y": 82.83333333333336
   }
  ],
  [
   {
    "x": 132.22222222222226,
    "y": 72.72222222222224
   },
   {
    "x": 124.0555555555556,
    "y": 78.94444444444447
   },
   {
    "x": 126.38888888888893,
    "y": 80.11111111111113
   }
  ],
  [
   {
    "x": 138.44444444444449,
    "y": 73.50000000000003
   },
   {
    "x": 126.00000000000004,
    "y": 77.38888888888891
   },
   {
    "x": 131.44444444444449,
    "y": 78.16666666666669
   }
  ],
  [
   {
    "x": 139.61111111111114,
    "y": 77.38888888888891
   },
   {
    "x": 133.00000000000003,
    "y": 75.83333333333336
   },
   {
    "x": 132.61111111111114,
    "y": 78.16666666666669
   }
  ],
  [
   {
    "x": 140.77777777777783,
    "y": 81.66666666666669
   },
   {
    "x": 132.61111111111114,
    "y": 76.61111111111113
   },
   {
    "x": 131.0555555555556,
    "y": 78.55555555555559
   }
  ],
  [
   {
    "x": 136.11111111111114,
    "y": 84.00000000000003
   },
   {
    "x": 133.00000000000003,
    "y": 77.38888888888891
   },
   {
    "x": 130.6666666666667,
    "y": 82.44444444444447
   }
  ],
  [
   {
    "x": 105.64815012613936,
    "y": 95.92592790391713
   },
   {
    "x": 84.64815012613934,
    "y": 103.31481679280603
   },
   {
    "x": 101.37037234836157,
    "y": 92.81481679280601
   }
  ],
  [
   {
    "x": 116.92592790391714,
    "y": 90.48148345947268
   },
   {
    "x": 95.53703901502824,
    "y": 96.31481679280601
   },
   {
    "x": 112.64815012613936,
    "y": 88.14815012613936
   }
  ],
  [
   {
    "x": 124.31481679280603,
    "y": 87.37037234836157
   },
   {
    "x": 125.4814834594727,
    "y": 106.81481679280603
   },
   {
    "x": 127.42592790391714,
    "y": 90.48148345947268
   }
  ],
  [
   {
    "x": 123.14815012613936,
    "y": 97.87037234836157
   },
   {
    "x": 124.70370568169491,
    "y": 109.53703901502824
   },
   {
    "x": 128.5925945705838,
    "y": 97.48148345947268
   }
  ],
  [
   {
    "x": 121.9814834594727,
    "y": 104.48148345947268
   },
   {
    "x": 126.25926123725047,
    "y": 119.25926123725047
   },
   {
    "x": 126.25926123725047,
    "y": 104.48148345947268
   }
  ],
  [
   {
    "x": 135.5925945705838,
    "y": 93.5925945705838
   },
   {
    "x": 132.48148345947268,
    "y": 105.64815012613936
   },
   {
    "x": 131.7037056816949,
    "y": 95.92592790391713
   }
  ],
  [
   {
    "x": 135.5925945705838,
    "y": 99.03703901502824
   },
   {
    "x": 131.31481679280603,
    "y": 105.25926123725047
   },
   {
    "x": 130.53703901502826,
    "y": 94.37037234836157
   }
  ],
  [
   {
    "x": 136.3703723483616,
    "y": 101.75926123725047
   },
   {
    "x": 132.0925945705838,
    "y": 109.53703901502824
   },
   {
    "x": 128.98148345947268,
    "y": 102.53703901502824
   }
  ],
  [
   {
    "x": 135.2037056816949,
    "y": 109.14815012613936
   },
   {
    "x": 131.31481679280603,
    "y": 116.14815012613936
   },
   {
    "x": 130.53703901502826,
    "y": 107.98148345947268
   }
  ],
  [
   {
    "x": 141.81481679280603,
    "y": 96.31481679280601
   },
   {
    "x": 139.0925945705838,
    "y": 108.37037234836158
   },
   {
    "x": 143.3703723483616,
    "y": 105.25926123725047
   }
  ],
  [
   {
    "x": 145.7037056816949,
    "y": 90.0925945705838
   },
   {
    "x": 142.2037056816949,
    "y": 102.14815012613936
   },
   {
    "x": 148.03703901502826,
    "y": 92.81481679280601
   }
  ],
  [
   {
    "x": 149.9814834594727,
    "y": 81.53703901502824
   },
   {
    "x": 146.0925945705838,
    "y": 95.53703901502824
   },
   {
    "x": 151.92592790391714,
    "y": 92.42592790391713
   }
  ],
  [
   {
    "x": 152.7037056816949,
    "y": 75.31481679280601
   },
   {
    "x": 149.5925945705838,
    "y": 90.0925945705838
   },
   {
    "x": 155.81481679280603,
    "y": 85.42592790391713
   }
  ],
  [
   {
    "x": 154.64815012613937,
    "y": 70.25926123725046
   },
   {
    "x": 153.09259457058383,
    "y": 84.25926123725046
   },
   {
    "x": 158.53703901502826,
    "y": 80.37037234836157
   }
  ],
  [
   {
    "x": 161.64815012613937,
    "y": 70.64815012613934
   },
   {
    "x": 155.42592790391714,
    "y": 73.37037234836157
   },
   {
    "x": 158.53703901502826,
    "y": 78.03703901502824
   }
  ],
  [
   {
    "x": 164.3703723483616,
    "y": 72.2037056816949
   },
   {
    "x": 157.3703723483616,
    "y": 74.14815012613934
   },
   {
    "x": 160.8703723483616,
    "y": 78.42592790391713
   }
  ],
  [
   {
    "x": 167.4814834594727,
    "y": 77.25926123725046
   },
   {
    "x": 162.42592790391714,
    "y": 74.14815012613934
   },
   {
    "x": 162.42592790391714,
    "y": 78.03703901502824
   }
  ],
  [
   {
    "x": 168.25926123725048,
    "y": 81.14815012613934
   },
   {
    "x": 160.8703723483616,
    "y": 75.31481679280601
   },
   {
    "x": 160.09259457058383,
    "y": 81.14815012613934
   }
  ],
  [
   {
    "x": 165.92592790391714,
    "y": 87.75926123725046
   },
   {
    "x": 164.75926123725048,
    "y": 79.59259457058378
   },
   {
    "x": 160.8703723483616,
    "y": 87.37037234836157
   }
  ],
  [
   {
    "x": 163.59259457058383,
    "y": 84.25926123725046
   },
   {
    "x": 164.75926123725048,
    "y": 96.31481679280601
   },
   {
    "x": 160.8703723483616,
    "y": 92.42592790391713
   }
  ],
  [
   {
    "x": 162.81481679280603,
    "y": 106.42592790391713
   },
   {
    "x": 163.20370568169494,
    "y": 90.48148345947268
   },
   {
    "x": 159.31481679280603,
    "y": 104.48148345947268
   }
  ],
  [
   {
    "x": 162.03703901502826,
    "y": 111.87037234836158
   },
   {
    "x": 161.25926123725048,
    "y": 100.98148345947268
   },
   {
    "x": 157.75926123725048,
    "y": 110.70370568169491
   }
  ],
  [
   {
    "x": 162.03703901502826,
    "y": 117.70370568169491
   },
   {
    "x": 159.31481679280603,
    "y": 105.64815012613936
   },
   {
    "x": 157.3703723483616,
    "y": 115.37037234836158
   }
  ],
  [
   {
    "x": 160.8703723483616,
    "y": 129.37037234836157
   },
   {
    "x": 158.92592790391714,
    "y": 113.03703901502824
   },
   {
    "x": 157.3703723483616,
    "y": 128.2037056816949
   }
  ],
  [
   {
    "x": 161.25926123725048,
    "y": 137.14815012613937
   },
   {
    "x": 157.3703723483616,
    "y": 124.31481679280603
   },
   {
    "x": 156.59259457058383,
    "y": 136.3703723483616
   }
  ],
  [
   {
    "x": 148.42592790391714,
    "y": 125.4814834594727
   },
   {
    "x": 151.53703901502826,
    "y": 106.03703901502824
   },
   {
    "x": 151.92592790391714,
    "y": 124.70370568169491
   }
  ],
  [
   {
    "x": 148.03703901502826,
    "y": 135.5925945705838
   },
   {
    "x": 151.14815012613937,
    "y": 118.0925945705838
   },
   {
    "x": 149.9814834594727,
    "y": 134.81481679280603
   }
  ],
  [
   {
    "x": 149.2037056816949,
    "y": 139.35184987386071
   },
   {
    "x": 150.3703723483616,
    "y": 133.1296276516385
   },
   {
    "x": 150.75926123725048,
    "y": 139.7407387627496
   }
  ],
  [
   {
    "x": 149.2037056816949,
    "y": 141.68518320719406
   },
   {
    "x": 150.75926123725048,
    "y": 137.01851654052737
   },
   {
    "x": 151.53703901502826,
    "y": 140.9074054294163
   }
  ],
  [
   {
    "x": 150.75926123725048,
    "y": 145.18518320719406
   },
   {
    "x": 150.3703723483616,
    "y": 138.96296098497183
   },
   {
    "x": 152.31481679280603,
    "y": 143.6296276516385
   }
  ],
  [
   {
    "x": 153.09259457058383,
    "y": 151.79629431830517
   },
   {
    "x": 151.14815012613937,
    "y": 142.07407209608294
   },
   {
    "x": 153.8703723483616,
    "y": 145.18518320719406
   }
  ],
  [
   {
    "x": 156.9814834594727,
    "y": 154.9074054294163
   },
   {
    "x": 153.09259457058383,
    "y": 147.9074054294163
   },
   {
    "x": 158.92592790391714,
    "y": 153.7407387627496
   }
  ],
  [
   {
    "x": 160.8703723483616,
    "y": 157.2407387627496
   },
   {
    "x": 156.9814834594727,
    "y": 152.96296098497183
   },
   {
    "x": 163.20370568169494,
    "y": 151.79629431830517
   }
  ],
  [
   {
    "x": 167.4814834594727,
    "y": 153.7407387627496
   },
   {
    "x": 159.7037056816949,
    "y": 153.7407387627496
   },
   {
    "x": 166.70370568169494,
    "y": 147.1296276516385
   }
  ],
  [
   {
    "x": 172.4074054294163,
    "y": 149.33333333333337
   },
   {
    "x": 161.5185165405274,
    "y": 152.0555555555556
   },
   {
    "x": 168.5185165405274,
    "y": 144.6666666666667
   }
  ],
  [
   {
    "x": 175.12962765163851,
    "y": 143.50000000000006
   },
   {
    "x": 165.0185165405274,
    "y": 150.50000000000006
   },
   {
    "x": 170.85184987386071,
    "y": 141.5555555555556
   }
  ],
  [
   {
    "x": 175.5185165405274,
    "y": 139.22222222222226
   },
   {
    "x": 169.29629431830517,
    "y": 146.61111111111114
   },
   {
    "x": 172.79629431830517,
    "y": 138.44444444444449
   }
  ],
  [
   {
    "x": 160.7407387627496,
    "y": 138.83333333333337
   },
   {
    "x": 157.2407387627496,
    "y": 134.5555555555556
   },
   {
    "x": 158.4074054294163,
    "y": 141.1666666666667
   }
  ],
  [
   {
    "x": 164.24073876274963,
    "y": 133.38888888888894
   },
   {
    "x": 159.57407209608294,
    "y": 142.72222222222226
   },
   {
    "x": 167.35184987386071,
    "y": 136.88888888888894
   }
  ],
  [
   {
    "x": 166.18518320719406,
    "y": 125.61111111111114
   },
   {
    "x": 165.0185165405274,
    "y": 140.00000000000003
   },
   {
    "x": 169.29629431830517,
    "y": 130.6666666666667
   }
  ],
  [
   {
    "x": 169.1666666666667,
    "y": 119.97222222222226
   },
   {
    "x": 168.00000000000006,
    "y": 134.75000000000003
   },
   {
    "x": 173.0555555555556,
    "y": 124.63888888888893
   }
  ],
  [
   {
    "x": 173.0555555555556,
    "y": 110.63888888888893
   },
   {
    "x": 169.94444444444449,
    "y": 130.08333333333337
   },
   {
    "x": 175.77777777777783,
    "y": 119.97222222222226
   }
  ],
  [
   {
    "x": 176.1666666666667,
    "y": 104.4166666666667
   },
   {
    "x": 173.44444444444449,
    "y": 118.4166666666667
   },
   {
    "x": 178.88888888888894,
    "y": 113.36111111111114
   }
  ],
  [
   {
    "x": 193.27777777777783,
    "y": 81.86111111111114
   },
   {
    "x": 187.8333333333334,
    "y": 76.41666666666669
   },
   {
    "x": 187.0555555555556,
    "y": 82.63888888888891
   }
  ],
  [
   {
    "x": 193.6666666666667,
    "y": 85.36111111111114
   },
   {
    "x": 187.4444444444445,
    "y": 79.5277777777778
   },
   {
    "x": 187.4444444444445,
    "y": 86.5277777777778
   }
  ],
  [
   {
    "x": 194.4444444444445,
    "y": 94.30555555555559
   },
   {
    "x": 189.77777777777783,
    "y": 79.5277777777778
   },
   {
    "x": 187.0555555555556,
    "y": 85.36111111111114
   }
  ],
  [
   {
    "x": 194.8333333333334,
    "y": 112.8425945705838
   },
   {
    "x": 190.9444444444445,
    "y": 130.73148345947268
   },
   {
    "x": 191.3333333333334,
    "y": 115.17592790391714
   }
  ],
  [
   {
    "x": 194.05555555555563,
    "y": 122.17592790391714
   },
   {
    "x": 190.1666666666667,
    "y": 131.1203723483616
   },
   {
    "x": 189.77777777777783,
    "y": 119.06481679280603
   }
  ],
  [
   {
    "x": 194.8333333333334,
    "y": 125.28703901502826
   },
   {
    "x": 192.50000000000006,
    "y": 133.8425945705838
   },
   {
    "x": 189.00000000000006,
    "y": 123.3425945705838
   }
  ],
  [
   {
    "x": 194.8333333333334,
    "y": 130.73148345947268
   },
   {
    "x": 192.50000000000006,
    "y": 143.56481679280603
   },
   {
    "x": 189.38888888888894,
    "y": 129.9537056816949
   }
  ],
  [
   {
    "x": 194.4444444444445,
    "y": 142.39815012613937
   },
   {
    "x": 192.50000000000006,
    "y": 150.56481679280603
   },
   {
    "x": 190.9444444444445,
    "y": 143.56481679280603
   }
  ],
  [
   {
    "x": 194.4444444444445,
    "y": 150.17592790391714
   },
   {
    "x": 191.3333333333334,
    "y": 156.00926123725048
   },
   {
    "x": 191.3333333333334,
    "y": 150.17592790391714
   }
  ],
  [
   {
    "x": 195.22222222222229,
    "y": 154.06481679280603
   },
   {
    "x": 190.1666666666667,
    "y": 164.56481679280603
   },
   {
    "x": 189.77777777777783,
    "y": 153.67592790391714
   }
  ],
  [
   {
    "x": 193.5370449490018,
    "y": 162.6203723483616
   },
   {
    "x": 187.70371161566845,
    "y": 173.1203723483616
   },
   {
    "x": 188.48148939344622,
    "y": 162.2314834594727
   }
  ],
  [
   {
    "x": 191.72222222222229,
    "y": 170.7870449490018
   },
   {
    "x": 185.88888888888894,
    "y": 177.3981560601129
   },
   {
    "x": 185.88888888888894,
    "y": 171.56482272677957
   }
  ],
  [
   {
    "x": 190.1666666666667,
    "y": 175.06482272677957
   },
   {
    "x": 183.5555555555556,
    "y": 180.8981560601129
   },
   {
    "x": 186.27777777777783,
    "y": 171.95371161566845
   }
  ],
  [
   {
    "x": 190.9444444444445,
    "y": 178.17593383789068
   },
   {
    "x": 181.22222222222229,
    "y": 188.2870449490018
   },
   {
    "x": 183.1666666666667,
    "y": 178.56482272677957
   }
  ],
  [
   {
    "x": 180.96295505099832,
    "y": 192.43517727322055
   },
   {
    "x": 177.8518439398872,
    "y": 187.7685106065539
   },
   {
    "x": 184.07406616210943,
    "y": 183.4907328287761
   }
  ],
  [
   {
    "x": 174.7407328287761,
    "y": 195.15739949544277
   },
   {
    "x": 180.57406616210943,
    "y": 186.9907328287761
   },
   {
    "x": 175.90739949544277,
    "y": 186.6018439398872
   }
  ],
  [
   {
    "x": 172.01851060655386,
    "y": 193.9907328287761
   },
   {
    "x": 179.79628838433166,
    "y": 186.21295505099832
   },
   {
    "x": 170.8518439398872,
    "y": 185.04628838433166
   }
  ],
  [
   {
    "x": 165.01851060655386,
    "y": 192.82406616210943
   },
   {
    "x": 173.57406616210943,
    "y": 188.54628838433166
   },
   {
    "x": 171.2407328287761,
    "y": 186.9907328287761
   }
  ],
  [
   {
    "x": 164.2407328287761,
    "y": 187.7685106065539
   },
   {
    "x": 172.40739949544275,
    "y": 189.32406616210943
   },
   {
    "x": 172.40739949544275,
    "y": 186.6018439398872
   }
  ],
  [
   {
    "x": 164.62962171766497,
    "y": 189.32406616210943
   },
   {
    "x": 168.90739949544275,
    "y": 184.2685106065539
   },
   {
    "x": 169.29628838433166,
    "y": 186.6018439398872
   }
  ],
  [
   {
    "x": 163.46295505099832,
    "y": 184.2685106065539
   },
   {
    "x": 170.46295505099832,
    "y": 185.82406616210943
   },
   {
    "x": 169.68517727322055,
    "y": 182.71295505099832
   }
  ],
  [
   {
    "x": 164.2407328287761,
    "y": 179.21295505099832
   },
   {
    "x": 168.90739949544275,
    "y": 185.04628838433166
   },
   {
    "x": 169.29628838433166,
    "y": 181.15739949544277
   }
  ],
  [
   {
    "x": 163.07406616210943,
    "y": 175.71295505099832
   },
   {
    "x": 167.3518439398872,
    "y": 183.4907328287761
   },
   {
    "x": 168.51851060655386,
    "y": 179.21295505099832
   }
  ],
  [
   {
    "x": 166.18517727322055,
    "y": 167.54628838433166
   },
   {
    "x": 166.96295505099832,
    "y": 179.9907328287761
   },
   {
    "x": 169.68517727322055,
    "y": 171.43517727322055
   }
  ],
  [
   {
    "x": 168.90739949544275,
    "y": 160.15739949544275
   },
   {
    "x": 167.7407328287761,
    "y": 173.37962171766497
   },
   {
    "x": 172.40739949544275,
    "y": 162.87962171766497
   }
  ],
  [
   {
    "x": 170.8518439398872,
    "y": 151.21295505099832
   },
   {
    "x": 168.90739949544275,
    "y": 166.76851060655386
   },
   {
    "x": 172.40739949544275,
    "y": 156.65739949544275
   }
  ],
  [
   {
    "x": 173.57406616210943,
    "y": 144.6018439398872
   },
   {
    "x": 171.62962171766497,
    "y": 156.65739949544275
   },
   {
    "x": 176.68517727322055,
    "y": 146.93517727322052
   }
  ],
  [
   {
    "x": 217.129621717665,
    "y": 77.97222222222224
   },
   {
    "x": 208.18517727322055,
    "y": 79.91666666666669
   },
   {
    "x": 212.46295505099832,
    "y": 82.25000000000003
   }
  ],
  [
   {
    "x": 221.79628838433166,
    "y": 81.47222222222224
   },
   {
    "x": 214.0185106065539,
    "y": 79.5277777777778
   },
   {
    "x": 214.79628838433166,
    "y": 82.63888888888891
   }
  ],
  [
   {
    "x": 227.629621717665,
    "y": 86.13888888888891
   },
   {
    "x": 218.68517727322055,
    "y": 81.08333333333336
   },
   {
    "x": 217.90739949544277,
    "y": 86.13888888888891
   }
  ],
  [
   {
    "x": 228.0185106065539,
    "y": 89.25000000000003
   },
   {
    "x": 221.79628838433166,
    "y": 85.75000000000003
   },
   {
    "x": 221.40739949544277,
    "y": 87.69444444444447
   }
  ],
  [
   {
    "x": 227.629621717665,
    "y": 90.4166666666667
   },
   {
    "x": 222.18517727322055,
    "y": 86.13888888888891
   },
   {
    "x": 222.18517727322055,
    "y": 89.63888888888891
   }
  ],
  [
   {
    "x": 227.37037828233514,
    "y": 107.39815012613936
   },
   {
    "x": 226.20371161566848,
    "y": 97.67592790391713
   },
   {
    "x": 224.6481560601129,
    "y": 103.50926123725047
   }
  ],
  [
   {
    "x": 226.20371161566848,
    "y": 112.45370568169491
   },
   {
    "x": 225.8148227267796,
    "y": 103.12037234836157
   },
   {
    "x": 223.09260050455737,
    "y": 107.39815012613936
   }
  ],
  [
   {
    "x": 223.48148939344625,
    "y": 118.28703901502824
   },
   {
    "x": 225.0370449490018,
    "y": 107.39815012613936
   },
   {
    "x": 221.1481560601129,
    "y": 111.67592790391713
   }
  ],
  [
   {
    "x": 221.1481560601129,
    "y": 122.56481679280603
   },
   {
    "x": 222.70371161566848,
    "y": 110.89815012613936
   },
   {
    "x": 218.42593383789068,
    "y": 115.17592790391714
   }
  ],
  [
   {
    "x": 199.75926717122402,
    "y": 104.28703901502824
   },
   {
    "x": 195.87037828233514,
    "y": 112.8425945705838
   },
   {
    "x": 201.31482272677957,
    "y": 108.56481679280603
   }
  ],
  [
   {
    "x": 204.0370449490018,
    "y": 101.95370568169491
   },
   {
    "x": 199.37037828233514,
    "y": 107.00926123725047
   },
   {
    "x": 202.48148939344625,
    "y": 107.39815012613936
   }
  ],
  [
   {
    "x": 207.5370449490018,
    "y": 100.00926123725047
   },
   {
    "x": 202.87037828233514,
    "y": 105.45370568169491
   },
   {
    "x": 207.5370449490018,
    "y": 104.67592790391713
   }
  ],
  [
   {
    "x": 212.98148939344625,
    "y": 98.45370568169491
   },
   {
    "x": 206.37037828233514,
    "y": 102.73148345947268
   },
   {
    "x": 212.20371161566845,
    "y": 101.95370568169491
   }
  ],
  [
   {
    "x": 216.87037828233514,
    "y": 96.89815012613936
   },
   {
    "x": 210.6481560601129,
    "y": 100.78703901502824
   },
   {
    "x": 215.31482272677957,
    "y": 101.17592790391713
   }
  ],
  [
   {
    "x": 230.87037828233514,
    "y": 90.67592790391713
   },
   {
    "x": 227.37037828233514,
    "y": 94.95370568169491
   },
   {
    "x": 231.6481560601129,
    "y": 93.78703901502824
   }
  ],
  [
   {
    "x": 233.98148939344625,
    "y": 87.56481679280601
   },
   {
    "x": 230.48148939344625,
    "y": 93.78703901502824
   },
   {
    "x": 234.75926717122402,
    "y": 91.06481679280601
   }
  ],
  [
   {
    "x": 236.70371161566848,
    "y": 82.12037234836157
   },
   {
    "x": 233.59260050455737,
    "y": 91.8425945705838
   },
   {
    "x": 239.0370449490018,
    "y": 83.28703901502824
   }
  ],
  [
   {
    "x": 239.4259338378907,
    "y": 77.4537056816949
   },
   {
    "x": 236.70371161566848,
    "y": 85.23148345947268
   },
   {
    "x": 240.59260050455737,
    "y": 81.73148345947268
   }
  ],
  [
   {
    "x": 241.75926717122402,
    "y": 102.73148345947268
   },
   {
    "x": 241.75926717122402,
    "y": 96.50926123725046
   },
   {
    "x": 237.87037828233514,
    "y": 102.3425945705838
   }
  ],
  [
   {
    "x": 241.75926717122402,
    "y": 105.8425945705838
   },
   {
    "x": 239.0370449490018,
    "y": 100.00926123725047
   },
   {
    "x": 236.3148227267796,
    "y": 105.06481679280603
   }
  ],
  [
   {
    "x": 240.59260050455737,
    "y": 109.3425945705838
   },
   {
    "x": 238.6481560601129,
    "y": 102.73148345947268
   },
   {
    "x": 236.3148227267796,
    "y": 108.95370568169491
   }
  ],
  [
   {
    "x": 241.37037828233514,
    "y": 108.95370568169491
   },
   {
    "x": 237.87037828233514,
    "y": 111.67592790391713
   },
   {
    "x": 241.75926717122402,
    "y": 112.8425945705838
   }
  ],
  [
   {
    "x": 244.87037828233514,
    "y": 105.8425945705838
   },
   {
    "x": 240.20371161566848,
    "y": 112.8425945705838
   },
   {
    "x": 247.98148939344625,
    "y": 108.56481679280603
   }
  ],
  [
   {
    "x": 248.75926717122402,
    "y": 102.3425945705838
   },
   {
    "x": 244.09260050455737,
    "y": 110.50926123725047
   },
   {
    "x": 252.6481560601129,
    "y": 104.67592790391713
   }
  ],
  [
   {
    "x": 251.87037828233514,
    "y": 99.62037234836157
   },
   {
    "x": 248.37037828233514,
    "y": 108.56481679280603
   },
   {
    "x": 255.37037828233514,
    "y": 102.3425945705838
   }
  ],
  [
   {
    "x": 255.37037828233514,
    "y": 96.12037234836157
   },
   {
    "x": 252.25926717122402,
    "y": 105.45370568169491
   },
   {
    "x": 256.9259338378907,
    "y": 98.45370568169491
   }
  ],
  [
   {
    "x": 258.87037828233514,
    "y": 91.8425945705838
   },
   {
    "x": 254.59260050455737,
    "y": 102.3425945705838
   },
   {
    "x": 263.1481560601129,
    "y": 94.56481679280601
   }
  ],
  [
   {
    "x": 261.20371161566845,
    "y": 88.3425945705838
   },
   {
    "x": 260.4259338378907,
    "y": 96.89815012613936
   },
   {
    "x": 267.8148227267796,
    "y": 89.12037234836157
   }
  ],
  [
   {
    "x": 245.25926717122402,
    "y": 120.2314834594727
   },
   {
    "x": 237.48148939344625,
    "y": 118.67592790391714
   },
   {
    "x": 242.1481560601129,
    "y": 117.12037234836158
   }
  ],
  [
   {
    "x": 249.53704494900182,
    "y": 117.12037234836158
   },
   {
    "x": 240.98148939344625,
    "y": 119.06481679280603
   },
   {
    "x": 246.4259338378907,
    "y": 114.78703901502824
   }
  ],
  [
   {
    "x": 256.5370449490018,
    "y": 112.06481679280603
   },
   {
    "x": 244.87037828233514,
    "y": 117.89815012613936
   },
   {
    "x": 249.9259338378907,
    "y": 110.89815012613936
   }
  ],
  [
   {
    "x": 260.0370449490018,
    "y": 107.00926123725047
   },
   {
    "x": 248.75926717122402,
    "y": 114.39815012613936
   },
   {
    "x": 254.98148939344625,
    "y": 105.06481679280603
   }
  ],
  [
   {
    "x": 264.3148227267796,
    "y": 101.56481679280601
   },
   {
    "x": 252.25926717122402,
    "y": 110.89815012613936
   },
   {
    "x": 260.0370449490018,
    "y": 101.17592790391713
   }
  ],
  [
   {
    "x": 268.2037116156685,
    "y": 96.12037234836157
   },
   {
    "x": 258.09260050455737,
    "y": 104.67592790391713
   },
   {
    "x": 263.9259338378907,
    "y": 96.50926123725046
   }
  ],
  [
   {
    "x": 286.87037828233514,
    "y": 66.43518320719403
   },
   {
    "x": 274.8148227267796,
    "y": 85.87962765163849
   },
   {
    "x": 282.59260050455737,
    "y": 64.49073876274959
   }
  ],
  [
   {
    "x": 289.59260050455737,
    "y": 60.21296098497181
   },
   {
    "x": 282.2037116156685,
    "y": 68.76851654052736
   },
   {
    "x": 285.3148227267796,
    "y": 58.65740542941625
   }
  ],
  [
   {
    "x": 290.75926717122405,
    "y": 54.37962765163847
   },
   {
    "x": 284.1481560601129,
    "y": 64.49073876274959
   },
   {
    "x": 285.7037116156685,
    "y": 56.324072096082915
   }
  ],
  [
   {
    "x": 290.37037828233514,
    "y": 48.54629431830514
   },
   {
    "x": 287.6481560601129,
    "y": 57.101849873860694
   },
   {
    "x": 286.09260050455737,
    "y": 50.87962765163847
   }
  ],
  [
   {
    "x": 289.59260050455737,
    "y": 44.657405429416244
   },
   {
    "x": 286.87037828233514,
    "y": 53.99073876274958
   },
   {
    "x": 285.3148227267796,
    "y": 48.93518320719402
   }
  ],
  [
   {
    "x": 286.87037828233514,
    "y": 40.76851654052736
   },
   {
    "x": 287.25926717122405,
    "y": 50.101849873860694
   },
   {
    "x": 281.4259338378907,
    "y": 46.2129609849718
   }
  ],
  [
   {
    "x": 282.2037116156685,
    "y": 38.43518320719402
   },
   {
    "x": 285.7037116156685,
    "y": 46.99073876274958
   },
   {
    "x": 281.4259338378907,
    "y": 44.26851654052736
   }
  ],
  [
   {
    "x": 278.3148227267796,
    "y": 38.04629431830514
   },
   {
    "x": 282.9814893934463,
    "y": 42.7129609849718
   },
   {
    "x": 278.3148227267796,
    "y": 43.49073876274958
   }
  ],
  [
   {
    "x": 274.0370449490018,
    "y": 39.60184987386069
   },
   {
    "x": 283.75926717122405,
    "y": 43.10184987386069
   },
   {
    "x": 273.6481560601129,
    "y": 46.2129609849718
   }
  ],
  [
   {
    "x": 269.75926717122405,
    "y": 42.7129609849718
   },
   {
    "x": 277.9259338378907,
    "y": 41.93518320719402
   },
   {
    "x": 274.4259338378907,
    "y": 46.2129609849718
   }
  ],
  [
   {
    "x": 267.8148227267796,
    "y": 46.601849873860694
   },
   {
    "x": 275.2037116156685,
    "y": 42.324072096082915
   },
   {
    "x": 273.6481560601129,
    "y": 48.93518320719402
   }
  ],
  [
   {
    "x": 264.3148227267796,
    "y": 50.49073876274958
   },
   {
    "x": 272.09260050455737,
    "y": 45.824072096082915
   },
   {
    "x": 268.2037116156685,
    "y": 52.824072096082915
   }
  ],
  [
   {
    "x": 261.9814893934463,
    "y": 54.76851654052736
   },
   {
    "x": 270.5370449490018,
    "y": 47.76851654052736
   },
   {
    "x": 265.87037828233514,
    "y": 56.71296098497181
   }
  ],
  [
   {
    "x": 260.0370449490018,
    "y": 59.43518320719403
   },
   {
    "x": 266.6481560601129,
    "y": 52.824072096082915
   },
   {
    "x": 265.4814893934463,
    "y": 60.21296098497181
   }
  ],
  [
   {
    "x": 258.4814893934463,
    "y": 66.04629431830514
   },
   {
    "x": 263.5370449490018,
    "y": 57.87962765163847
   },
   {
    "x": 263.9259338378907,
    "y": 64.87962765163847
   }
  ],
  [
   {
    "x": 258.09260050455737,
    "y": 70.32407209608292
   },
   {
    "x": 262.75926717122405,
    "y": 62.546294318305144
   },
   {
    "x": 261.59260050455737,
    "y": 71.1018498738607
   }
  ],
  [
   {
    "x": 273.7777777777779,
    "y": 98.8425945705838
   },
   {
    "x": 274.55555555555566,
    "y": 108.56481679280603
   },
   {
    "x": 277.66666666666674,
    "y": 105.06481679280603
   }
  ],
  [
   {
    "x": 270.66666666666674,
    "y": 105.8425945705838
   },
   {
    "x": 273.00000000000006,
    "y": 114.78703901502824
   },
   {
    "x": 278.05555555555566,
    "y": 105.45370568169491
   }
  ],
  [
   {
    "x": 269.88888888888897,
    "y": 110.89815012613936
   },
   {
    "x": 271.4444444444445,
    "y": 121.78703901502824
   },
   {
    "x": 276.88888888888897,
    "y": 110.89815012613936
   }
  ],
  [
   {
    "x": 265.6111111111112,
    "y": 119.06481679280603
   },
   {
    "x": 269.50000000000006,
    "y": 133.06481679280603
   },
   {
    "x": 275.3333333333334,
    "y": 115.17592790391714
   }
  ],
  [
   {
    "x": 264.96295505099835,
    "y": 126.8425945705838
   },
   {
    "x": 268.46295505099835,
    "y": 138.89815012613937
   },
   {
    "x": 273.5185106065539,
    "y": 126.45370568169491
   }
  ],
  [
   {
    "x": 261.46295505099835,
    "y": 129.9537056816949
   },
   {
    "x": 267.6851772732206,
    "y": 143.17592790391714
   },
   {
    "x": 271.57406616210943,
    "y": 133.06481679280603
   }
  ],
  [
   {
    "x": 262.2407328287761,
    "y": 133.8425945705838
   },
   {
    "x": 268.07406616210943,
    "y": 144.3425945705838
   },
   {
    "x": 270.0185106065539,
    "y": 136.17592790391714
   }
  ],
  [
   {
    "x": 262.2407328287761,
    "y": 139.28703901502826
   },
   {
    "x": 267.6851772732206,
    "y": 147.06481679280603
   },
   {
    "x": 270.79628838433166,
    "y": 139.28703901502826
   }
  ],
  [
   {
    "x": 263.4073994954428,
    "y": 143.17592790391714
   },
   {
    "x": 268.85184393988726,
    "y": 148.6203723483616
   },
   {
    "x": 270.0185106065539,
    "y": 140.8425945705838
   }
  ],
  [
   {
    "x": 260.6851772732206,
    "y": 145.50926123725048
   },
   {
    "x": 269.2407328287761,
    "y": 153.28703901502826
   },
   {
    "x": 270.79628838433166,
    "y": 144.7314834594727
   }
  ],
  [
   {
    "x": 261.8518439398872,
    "y": 149.78703901502826
   },
   {
    "x": 269.62962171766503,
    "y": 155.2314834594727
   },
   {
    "x": 270.4073994954428,
    "y": 147.4537056816949
   }
  ],
  [
   {
    "x": 263.0185106065539,
    "y": 152.25000000000006
   },
   {
    "x": 270.79628838433166,
    "y": 159.63888888888894
   },
   {
    "x": 269.2407328287761,
    "y": 150.3055555555556
   }
  ],
  [
   {
    "x": 263.79628838433166,
    "y": 155.75000000000006
   },
   {
    "x": 272.35184393988726,
    "y": 164.3055555555556
   },
   {
    "x": 268.46295505099835,
    "y": 152.25000000000006
   }
  ],
  [
   {
    "x": 282.07406616210943,
    "y": 132.4166666666667
   },
   {
    "x": 279.35184393988726,
    "y": 145.25000000000006
   },
   {
    "x": 284.4073994954428,
    "y": 140.19444444444449
   }
  ],
  [
   {
    "x": 298.79628838433166,
    "y": 130.47222222222226
   },
   {
    "x": 287.12962171766503,
    "y": 151.47222222222226
   },
   {
    "x": 292.96295505099835,
    "y": 129.69444444444449
   }
  ],
  [
   {
    "x": 286.35184393988726,
    "y": 123.47222222222226
   },
   {
    "x": 282.46295505099835,
    "y": 139.02777777777783
   },
   {
    "x": 287.9073994954428,
    "y": 131.25000000000003
   }
  ],
  [
   {
    "x": 301.9073994954428,
    "y": 123.86111111111114
   },
   {
    "x": 291.4073994954428,
    "y": 135.9166666666667
   },
   {
    "x": 295.6851772732206,
    "y": 121.52777777777781
   }
  ],
  [
   {
    "x": 291.0185106065539,
    "y": 114.52777777777781
   },
   {
    "x": 286.7407328287761,
    "y": 130.08333333333337
   },
   {
    "x": 293.35184393988726,
    "y": 127.36111111111114
   }
  ],
  [
   {
    "x": 304.75926717122405,
    "y": 117.25000000000003
   },
   {
    "x": 295.42593383789074,
    "y": 126.19444444444449
   },
   {
    "x": 300.09260050455737,
    "y": 114.9166666666667
   }
  ],
  [
   {
    "x": 295.8148227267796,
    "y": 107.13888888888891
   },
   {
    "x": 291.92593383789074,
    "y": 120.36111111111114
   },
   {
    "x": 297.37037828233514,
    "y": 117.25000000000003
   }
  ],
  [
   {
    "x": 297.37037828233514,
    "y": 117.25000000000003
   },
   {
    "x": 298.5370449490018,
    "y": 111.4166666666667
   },
   {
    "x": 300.09260050455737,
    "y": 113.36111111111114
   }
  ],
  [
   {
    "x": 298.5370449490018,
    "y": 102.47222222222226
   },
   {
    "x": 296.59260050455737,
    "y": 114.9166666666667
   },
   {
    "x": 300.09260050455737,
    "y": 107.9166666666667
   }
  ],
  [
   {
    "x": 307.4814893934463,
    "y": 113.36111111111114
   },
   {
    "x": 298.1481560601129,
    "y": 118.4166666666667
   },
   {
    "x": 306.3148227267796,
    "y": 104.02777777777781
   }
  ],
  [
   {
    "x": 309.0370449490018,
    "y": 107.9166666666667
   },
   {
    "x": 302.8148227267796,
    "y": 113.75000000000003
   },
   {
    "x": 308.64815606011297,
    "y": 99.75000000000003
   }
  ],
  [
   {
    "x": 302.0370449490018,
    "y": 95.47222222222226
   },
   {
    "x": 298.5370449490018,
    "y": 110.25000000000003
   },
   {
    "x": 303.2037116156685,
    "y": 105.97222222222226
   }
  ],
  [
   {
    "x": 304.75926717122405,
    "y": 89.25000000000003
   },
   {
    "x": 302.42593383789074,
    "y": 102.86111111111114
   },
   {
    "x": 305.92593383789074,
    "y": 100.52777777777781
   }
  ],
  [
   {
    "x": 307.87037828233514,
    "y": 86.5277777777778
   },
   {
    "x": 304.37037828233514,
    "y": 99.75000000000003
   },
   {
    "x": 309.0370449490018,
    "y": 95.08333333333336
   }
  ],
  [
   {
    "x": 311.37037828233514,
    "y": 102.86111111111114
   },
   {
    "x": 305.92593383789074,
    "y": 104.4166666666667
   },
   {
    "x": 309.8148227267796,
    "y": 98.58333333333336
   }
  ],
  [
   {
    "x": 313.7037116156685,
    "y": 98.97222222222226
   },
   {
    "x": 307.09260050455737,
    "y": 103.25000000000003
   },
   {
    "x": 310.59260050455737,
    "y": 96.63888888888891
   }
  ],
  [
   {
    "x": 316.42593383789074,
    "y": 90.80555555555559
   },
   {
    "x": 311.75926717122405,
    "y": 97.02777777777781
   },
   {
    "x": 311.37037828233514,
    "y": 92.75000000000003
   }
  ],
  [
   {
    "x": 326.4073994954428,
    "y": 101.95370568169491
   },
   {
    "x": 328.7407328287761,
    "y": 123.7314834594727
   },
   {
    "x": 333.01851060655395,
    "y": 108.17592790391713
   }
  ],
  [
   {
    "x": 328.35184393988726,
    "y": 89.50926123725046
   },
   {
    "x": 330.2962883843317,
    "y": 111.28703901502824
   },
   {
    "x": 335.7407328287761,
    "y": 100.00926123725047
   }
  ],
  [
   {
    "x": 331.46295505099835,
    "y": 80.17592790391713
   },
   {
    "x": 332.2407328287761,
    "y": 99.62037234836157
   },
   {
    "x": 338.85184393988726,
    "y": 87.9537056816949
   }
  ],
  [
   {
    "x": 331.85184393988726,
    "y": 69.67592790391713
   },
   {
    "x": 335.35184393988726,
    "y": 92.23148345947268
   },
   {
    "x": 340.4073994954428,
    "y": 75.89815012613934
   }
  ],
  [
   {
    "x": 333.4073994954428,
    "y": 61.12037234836156
   },
   {
    "x": 338.46295505099835,
    "y": 84.8425945705838
   },
   {
    "x": 340.4073994954428,
    "y": 65.78703901502823
   }
  ],
  [
   {
    "x": 347.4073994954428,
    "y": 88.3425945705838
   },
   {
    "x": 340.4073994954428,
    "y": 105.06481679280603
   },
   {
    "x": 342.35184393988726,
    "y": 90.67592790391713
   }
  ],
  [
   {
    "x": 350.9073994954428,
    "y": 76.28703901502824
   },
   {
    "x": 341.1851772732206,
    "y": 97.28703901502824
   },
   {
    "x": 343.9073994954428,
    "y": 77.84259457058378
   }
  ],
  [
   {
    "x": 360.62962171766503,
    "y": 62.28703901502823
   },
   {
    "x": 344.2962883843317,
    "y": 80.17592790391713
   },
   {
    "x": 348.5740661621095,
    "y": 63.064816792806006
   }
  ],
  [
   {
    "x": 334.1851772732206,
    "y": 48.67592790391711
   },
   {
    "x": 338.46295505099835,
    "y": 69.67592790391713
   },
   {
    "x": 341.5740661621095,
    "y": 55.28703901502823
   }
  ],
  [
   {
    "x": 361.01851060655395,
    "y": 56.842594570583785
   },
   {
    "x": 352.85184393988726,
    "y": 66.17592790391713
   },
   {
    "x": 352.85184393988726,
    "y": 57.23148345947267
   }
  ],
  [
   {
    "x": 330.2962883843317,
    "y": 41.28703901502823
   },
   {
    "x": 340.01851060655395,
    "y": 59.9537056816949
   },
   {
    "x": 342.35184393988726,
    "y": 54.89815012613934
   }
  ],
  [
   {
    "x": 364.9073994954428,
    "y": 52.17592790391711
   },
   {
    "x": 351.6851772732206,
    "y": 61.12037234836156
   },
   {
    "x": 355.1851772732206,
    "y": 52.95370568169489
   }
  ],
  [
   {
    "x": 329.64815606011297,
    "y": 37.1388888888889
   },
   {
    "x": 339.3703782823352,
    "y": 56.194444444444464
   },
   {
    "x": 342.4814893934463,
    "y": 50.36111111111113
   }
  ],
  [
   {
    "x": 330.42593383789074,
    "y": 25.861111111111118
   },
   {
    "x": 340.92593383789074,
    "y": 52.69444444444446
   },
   {
    "x": 342.8703782823352,
    "y": 48.80555555555557
   }
  ],
  [
   {
    "x": 330.0370449490018,
    "y": 22.361111111111118
   },
   {
    "x": 342.09260050455737,
    "y": 49.972222222222236
   },
   {
    "x": 344.42593383789074,
    "y": 45.69444444444446
   }
  ],
  [
   {
    "x": 333.66666666666674,
    "y": 12.898150126139328
   },
   {
    "x": 340.66666666666674,
    "y": 40.120372348361556
   },
   {
    "x": 344.55555555555566,
    "y": 37.398150126139335
   }
  ],
  [
   {
    "x": 346.5000000000001,
    "y": 11.34259457058377
   },
   {
    "x": 340.2777777777779,
    "y": 31.95370568169489
   },
   {
    "x": 344.94444444444457,
    "y": 30.009261237250442
   }
  ],
  [
   {
    "x": 347.6666666666668,
    "y": 14.453705681694883
   },
   {
    "x": 343.0000000000001,
    "y": 30.78703901502822
   },
   {
    "x": 345.3333333333334,
    "y": 33.120372348361556
   }
  ],
  [
   {
    "x": 351.1666666666668,
    "y": 25.731483459472663
   },
   {
    "x": 343.7777777777779,
    "y": 30.39815012613933
   },
   {
    "x": 346.1111111111112,
    "y": 35.45370568169489
   }
  ],
  [
   {
    "x": 351.94444444444457,
    "y": 29.231483459472663
   },
   {
    "x": 345.3333333333334,
    "y": 33.120372348361556
   },
   {
    "x": 348.05555555555566,
    "y": 36.23148345947267
   }
  ],
  [
   {
    "x": 354.2777777777779,
    "y": 32.73148345947266
   },
   {
    "x": 346.5000000000001,
    "y": 31.564816792806
   },
   {
    "x": 346.88888888888897,
    "y": 35.45370568169489
   }
  ],
  [
   {
    "x": 355.44444444444457,
    "y": 35.84259457058378
   },
   {
    "x": 348.05555555555566,
    "y": 33.898150126139335
   },
   {
    "x": 349.22222222222234,
    "y": 40.120372348361556
   }
  ],
  [
   {
    "x": 355.44444444444457,
    "y": 41.28703901502823
   },
   {
    "x": 350.7777777777779,
    "y": 36.620372348361556
   },
   {
    "x": 349.6111111111112,
    "y": 40.50926123725045
   }
  ],
  [
   {
    "x": 357.0000000000001,
    "y": 36.620372348361556
   },
   {
    "x": 351.55555555555566,
    "y": 44.398150126139335
   },
   {
    "x": 355.05555555555566,
    "y": 44.00926123725045
   }
  ],
  [
   {
    "x": 363.6111111111112,
    "y": 31.17592790391711
   },
   {
    "x": 355.05555555555566,
    "y": 41.28703901502823
   },
   {
    "x": 360.5000000000001,
    "y": 40.50926123725045
   }
  ],
  [
   {
    "x": 373.72222222222234,
    "y": 27.67592790391711
   },
   {
    "x": 360.88888888888897,
    "y": 37.00926123725044
   },
   {
    "x": 366.72222222222234,
    "y": 38.17592790391711
   }
  ],
  [
   {
    "x": 374.5000000000001,
    "y": 31.17592790391711
   },
   {
    "x": 369.05555555555566,
    "y": 35.064816792806
   },
   {
    "x": 371.388888888889,
    "y": 36.620372348361556
   }
  ],
  [
   {
    "x": 382.6666666666668,
    "y": 32.34259457058378
   },
   {
    "x": 371.388888888889,
    "y": 33.50926123725044
   },
   {
    "x": 372.94444444444457,
    "y": 36.620372348361556
   }
  ],
  [
   {
    "x": 383.05555555555566,
    "y": 35.84259457058378
   },
   {
    "x": 374.888888888889,
    "y": 35.84259457058378
   },
   {
    "x": 376.44444444444457,
    "y": 38.564816792806
   }
  ],
  [
   {
    "x": 388.5000000000001,
    "y": 40.50926123725045
   },
   {
    "x": 376.44444444444457,
    "y": 35.064816792806
   },
   {
    "x": 376.8333333333334,
    "y": 39.73148345947267
   }
  ],
  [
   {
    "x": 389.2777777777779,
    "y": 44.00926123725045
   },
   {
    "x": 379.94444444444457,
    "y": 38.95370568169489
   },
   {
    "x": 383.8333333333334,
    "y": 43.23148345947267
   }
  ],
  [
   {
    "x": 390.44444444444457,
    "y": 45.564816792806006
   },
   {
    "x": 381.5000000000001,
    "y": 40.50926123725045
   },
   {
    "x": 383.8333333333334,
    "y": 46.73148345947267
   }
  ],
  [
   {
    "x": 391.22222222222234,
    "y": 49.064816792806006
   },
   {
    "x": 383.8333333333334,
    "y": 45.564816792806006
   },
   {
    "x": 383.05555555555566,
    "y": 50.23148345947267
   }
  ],
  [
   {
    "x": 391.61111111111126,
    "y": 52.95370568169489
   },
   {
    "x": 384.6111111111112,
    "y": 46.73148345947267
   },
   {
    "x": 383.44444444444457,
    "y": 52.95370568169489
   }
  ],
  [
   {
    "x": 392.388888888889,
    "y": 56.842594570583785
   },
   {
    "x": 384.22222222222234,
    "y": 49.064816792806006
   },
   {
    "x": 382.2777777777779,
    "y": 54.89815012613934
   }
  ],
  [
   {
    "x": 387.72222222222234,
    "y": 63.4537056816949
   },
   {
    "x": 383.8333333333334,
    "y": 51.78703901502823
   },
   {
    "x": 379.94444444444457,
    "y": 59.564816792806006
   }
  ],
  [
   {
    "x": 383.05555555555566,
    "y": 66.56481679280601
   },
   {
    "x": 381.888888888889,
    "y": 56.4537056816949
   },
   {
    "x": 379.1666666666668,
    "y": 59.564816792806006
   }
  ],
  [
   {
    "x": 378.0000000000001,
    "y": 73.56481679280601
   },
   {
    "x": 382.2777777777779,
    "y": 58.00926123725045
   },
   {
    "x": 376.44444444444457,
    "y": 63.842594570583785
   }
  ],
  [
   {
    "x": 373.72222222222234,
    "y": 75.89815012613934
   },
   {
    "x": 378.0000000000001,
    "y": 64.62037234836157
   },
   {
    "x": 372.55555555555566,
    "y": 69.67592790391713
   }
  ],
  [
   {
    "x": 366.46295505099835,
    "y": 95.3425945705838
   },
   {
    "x": 354.4073994954428,
    "y": 87.9537056816949
   },
   {
    "x": 362.96295505099835,
    "y": 87.17592790391713
   }
  ],
  [
   {
    "x": 373.85184393988726,
    "y": 91.06481679280601
   },
   {
    "x": 362.96295505099835,
    "y": 91.06481679280601
   },
   {
    "x": 370.35184393988726,
    "y": 85.62037234836157
   }
  ],
  [
   {
    "x": 383.1851772732206,
    "y": 91.06481679280601
   },
   {
    "x": 366.85184393988726,
    "y": 87.56481679280601
   },
   {
    "x": 382.01851060655395,
    "y": 86.39815012613934
   }
  ],
  [
   {
    "x": 389.7962883843317,
    "y": 93.39815012613936
   },
   {
    "x": 378.12962171766503,
    "y": 85.62037234836157
   },
   {
    "x": 387.0740661621095,
    "y": 86.39815012613934
   }
  ],
  [
   {
    "x": 387.85184393988726,
    "y": 77.06481679280601
   },
   {
    "x": 370.35184393988726,
    "y": 77.06481679280601
   },
   {
    "x": 378.51851060655395,
    "y": 81.3425945705838
   }
  ],
  [
   {
    "x": 396.7962883843317,
    "y": 84.06481679280601
   },
   {
    "x": 383.9629550509984,
    "y": 79.00926123725046
   },
   {
    "x": 382.4073994954428,
    "y": 83.28703901502824
   }
  ],
  [
   {
    "x": 401.85184393988726,
    "y": 91.06481679280601
   },
   {
    "x": 391.7407328287762,
    "y": 83.67592790391713
   },
   {
    "x": 391.7407328287762,
    "y": 86.78703901502824
   }
  ],
  [
   {
    "x": 384.35184393988726,
    "y": 165.73148939344622
   },
   {
    "x": 394.0740661621095,
    "y": 147.45371161566845
   },
   {
    "x": 386.2962883843317,
    "y": 153.67593383789068
   }
  ],
  [
   {
    "x": 376.5740661621095,
    "y": 174.67593383789068
   },
   {
    "x": 384.35184393988726,
    "y": 161.06482272677957
   },
   {
    "x": 376.1851772732206,
    "y": 164.17593383789068
   }
  ],
  [
   {
    "x": 371.51851060655395,
    "y": 177.7870449490018
   },
   {
    "x": 376.9629550509984,
    "y": 168.06482272677957
   },
   {
    "x": 371.9073994954428,
    "y": 169.6203782823351
   }
  ],
  [
   {
    "x": 361.4073994954428,
    "y": 185.17593383789068
   },
   {
    "x": 372.2962883843317,
    "y": 171.95371161566845
   },
   {
    "x": 364.51851060655395,
    "y": 174.2870449490018
   }
  ],
  [
   {
    "x": 360.62962171766503,
    "y": 181.2870449490018
   },
   {
    "x": 365.2962883843317,
    "y": 176.6203782823351
   },
   {
    "x": 360.62962171766503,
    "y": 177.3981560601129
   }
  ],
  [
   {
    "x": 352.85184393988726,
    "y": 184.7870449490018
   },
   {
    "x": 364.12962171766503,
    "y": 177.7870449490018
   },
   {
    "x": 355.1851772732206,
    "y": 179.34260050455734
   }
  ],
  [
   {
    "x": 339.62962171766503,
    "y": 186.73148939344622
   },
   {
    "x": 356.35184393988726,
    "y": 181.2870449490018
   },
   {
    "x": 343.51851060655395,
    "y": 179.34260050455734
   }
  ],
  [
   {
    "x": 326.4073994954428,
    "y": 184.3981560601129
   },
   {
    "x": 345.85184393988726,
    "y": 183.62037828233514
   },
   {
    "x": 339.62962171766503,
    "y": 180.1203782823351
   }
  ],
  [
   {
    "x": 307.7407328287761,
    "y": 175.84260050455734
   },
   {
    "x": 337.2962883843317,
    "y": 182.45371161566845
   },
   {
    "x": 336.9073994954428,
    "y": 178.95371161566845
   }
  ],
  [
   {
    "x": 306.5740661621095,
    "y": 171.56482272677957
   },
   {
    "x": 334.5740661621095,
    "y": 178.95371161566845
   },
   {
    "x": 334.96295505099835,
    "y": 177.3981560601129
   }
  ],
  [
   {
    "x": 313.1851772732206,
    "y": 171.56482272677957
   },
   {
    "x": 333.7962883843317,
    "y": 181.2870449490018
   },
   {
    "x": 334.1851772732206,
    "y": 177.7870449490018
   }
  ],
  [
   {
    "x": 312.0185106065539,
    "y": 167.67593383789068
   },
   {
    "x": 328.35184393988726,
    "y": 176.23148939344622
   },
   {
    "x": 328.7407328287761,
    "y": 174.2870449490018
   }
  ],
  [
   {
    "x": 315.5185106065539,
    "y": 168.45371161566845
   },
   {
    "x": 327.96295505099835,
    "y": 175.45371161566845
   },
   {
    "x": 328.35184393988726,
    "y": 173.8981560601129
   }
  ],
  [
   {
    "x": 314.7407328287761,
    "y": 164.95371161566845
   },
   {
    "x": 321.35184393988726,
    "y": 170.3981560601129
   },
   {
    "x": 321.7407328287761,
    "y": 167.67593383789068
   }
  ],
  [
   {
    "x": 315.5185106065539,
    "y": 162.23148939344622
   },
   {
    "x": 319.4073994954428,
    "y": 170.009267171224
   },
   {
    "x": 321.35184393988726,
    "y": 167.2870449490018
   }
  ],
  [
   {
    "x": 314.7407328287761,
    "y": 158.34260050455734
   },
   {
    "x": 319.0185106065539,
    "y": 166.8981560601129
   },
   {
    "x": 320.5740661621095,
    "y": 164.17593383789068
   }
  ],
  [
   {
    "x": 315.5185106065539,
    "y": 145.509267171224
   },
   {
    "x": 318.2407328287761,
    "y": 164.17593383789068
   },
   {
    "x": 320.1851772732206,
    "y": 153.2870449490018
   }
  ],
  [
   {
    "x": 318.62962171766503,
    "y": 142.78704494900177
   },
   {
    "x": 317.46295505099835,
    "y": 151.73148939344622
   },
   {
    "x": 322.12962171766503,
    "y": 148.6203782823351
   }
  ],
  [
   {
    "x": 320.1851772732206,
    "y": 137.34260050455734
   },
   {
    "x": 320.1851772732206,
    "y": 149.009267171224
   },
   {
    "x": 324.0740661621095,
    "y": 146.28704494900177
   }
  ],
  [
   {
    "x": 323.2962883843317,
    "y": 138.1203782823351
   },
   {
    "x": 321.35184393988726,
    "y": 143.95371161566845
   },
   {
    "x": 326.01851060655395,
    "y": 142.78704494900177
   }
  ],
  [
   {
    "x": 326.4073994954428,
    "y": 130.34260050455734
   },
   {
    "x": 324.0740661621095,
    "y": 142.39815606011288
   },
   {
    "x": 329.51851060655395,
    "y": 140.45371161566845
   }
  ],
  [
   {
    "x": 334.96295505099835,
    "y": 126.06482272677955
   },
   {
    "x": 326.7962883843317,
    "y": 136.17593383789065
   },
   {
    "x": 333.4073994954428,
    "y": 136.95371161566845
   }
  ],
  [
   {
    "x": 358.94444444444457,
    "y": 113.10184987386071
   },
   {
    "x": 375.2777777777779,
    "y": 102.60184987386071
   },
   {
    "x": 376.44444444444457,
    "y": 104.54629431830516
   }
  ],
  [
   {
    "x": 376.44444444444457,
    "y": 104.15740542941626
   },
   {
    "x": 383.8333333333334,
    "y": 98.32407209608293
   },
   {
    "x": 384.22222222222234,
    "y": 100.26851654052737
   }
  ],
  [
   {
    "x": 390.8333333333334,
    "y": 95.9907387627496
   },
   {
    "x": 383.44444444444457,
    "y": 100.65740542941626
   },
   {
    "x": 390.8333333333334,
    "y": 99.1018498738607
   }
  ],
  [
   {
    "x": 367.1111111111112,
    "y": 124.76851654052739
   },
   {
    "x": 352.72222222222234,
    "y": 130.21296098497183
   },
   {
    "x": 354.6666666666668,
    "y": 123.21296098497183
   }
  ],
  [
   {
    "x": 377.22222222222234,
    "y": 118.93518320719404
   },
   {
    "x": 360.1111111111112,
    "y": 125.15740542941627
   },
   {
    "x": 364.7777777777779,
    "y": 119.32407209608293
   }
  ],
  [
   {
    "x": 381.888888888889,
    "y": 116.60184987386071
   },
   {
    "x": 367.1111111111112,
    "y": 120.10184987386071
   },
   {
    "x": 374.1111111111112,
    "y": 114.26851654052737
   }
  ],
  [
   {
    "x": 386.55555555555566,
    "y": 115.43518320719404
   },
   {
    "x": 373.72222222222234,
    "y": 115.82407209608293
   },
   {
    "x": 378.388888888889,
    "y": 111.93518320719404
   }
  ],
  [
   {
    "x": 394.72222222222234,
    "y": 109.60184987386071
   },
   {
    "x": 375.6666666666668,
    "y": 115.82407209608293
   },
   {
    "x": 384.6111111111112,
    "y": 107.65740542941627
   }
  ],
  [
   {
    "x": 409.5000000000001,
    "y": 90.54629431830514
   },
   {
    "x": 397.44444444444457,
    "y": 95.9907387627496
   },
   {
    "x": 405.22222222222234,
    "y": 96.76851654052737
   }
  ],
  [
   {
    "x": 430.5000000000001,
    "y": 94.82407209608293
   },
   {
    "x": 414.1666666666668,
    "y": 98.71296098497182
   },
   {
    "x": 416.888888888889,
    "y": 94.43518320719404
   }
  ],
  [
   {
    "x": 434.388888888889,
    "y": 90.15740542941626
   },
   {
    "x": 425.05555555555566,
    "y": 95.21296098497182
   },
   {
    "x": 427.0000000000001,
    "y": 89.76851654052737
   }
  ],
  [
   {
    "x": 437.888888888889,
    "y": 84.71296098497182
   },
   {
    "x": 429.3333333333335,
    "y": 90.54629431830514
   },
   {
    "x": 430.888888888889,
    "y": 84.32407209608293
   }
  ],
  [
   {
    "x": 436.72222222222234,
    "y": 78.1018498738607
   },
   {
    "x": 433.22222222222234,
    "y": 86.65740542941626
   },
   {
    "x": 431.6666666666668,
    "y": 81.21296098497182
   }
  ],
  [
   {
    "x": 437.11111111111126,
    "y": 81.21296098497182
   },
   {
    "x": 430.11111111111126,
    "y": 86.26851654052737
   },
   {
    "x": 430.5000000000001,
    "y": 81.99073876274959
   }
  ],
  [
   {
    "x": 435.94444444444457,
    "y": 74.99073876274959
   },
   {
    "x": 431.6666666666668,
    "y": 82.37962765163849
   },
   {
    "x": 430.888888888889,
    "y": 76.93518320719403
   }
  ],
  [
   {
    "x": 433.61111111111126,
    "y": 71.87962765163847
   },
   {
    "x": 432.44444444444457,
    "y": 80.04629431830514
   },
   {
    "x": 429.72222222222234,
    "y": 78.1018498738607
   }
  ],
  [
   {
    "x": 428.94444444444457,
    "y": 70.32407209608292
   },
   {
    "x": 432.8333333333335,
    "y": 76.15740542941626
   },
   {
    "x": 429.72222222222234,
    "y": 76.93518320719403
   }
  ],
  [
   {
    "x": 422.72222222222234,
    "y": 71.87962765163847
   },
   {
    "x": 430.11111111111126,
    "y": 73.43518320719403
   },
   {
    "x": 425.44444444444457,
    "y": 75.76851654052737
   }
  ],
  [
   {
    "x": 414.94444444444457,
    "y": 75.76851654052737
   },
   {
    "x": 423.888888888889,
    "y": 73.04629431830514
   },
   {
    "x": 422.3333333333335,
    "y": 76.54629431830514
   }
  ],
  [
   {
    "x": 413.7777777777779,
    "y": 82.37962765163849
   },
   {
    "x": 419.61111111111126,
    "y": 75.76851654052737
   },
   {
    "x": 417.2777777777779,
    "y": 82.37962765163849
   }
  ],
  [
   {
    "x": 407.81482272677965,
    "y": 114.13888888888893
   },
   {
    "x": 408.2037116156685,
    "y": 102.47222222222226
   },
   {
    "x": 409.7592671712241,
    "y": 112.19444444444447
   }
  ],
  [
   {
    "x": 408.9814893934463,
    "y": 117.25000000000003
   },
   {
    "x": 408.5926005045574,
    "y": 109.86111111111114
   },
   {
    "x": 411.31482272677965,
    "y": 114.52777777777781
   }
  ],
  [
   {
    "x": 412.4814893934463,
    "y": 120.36111111111114
   },
   {
    "x": 409.7592671712241,
    "y": 113.36111111111114
   },
   {
    "x": 413.2592671712241,
    "y": 114.13888888888893
   }
  ],
  [
   {
    "x": 417.14815606011297,
    "y": 121.9166666666667
   },
   {
    "x": 410.5370449490019,
    "y": 115.30555555555559
   },
   {
    "x": 416.7592671712241,
    "y": 116.47222222222226
   }
  ],
  [
   {
    "x": 423.3703782823352,
    "y": 121.13888888888893
   },
   {
    "x": 413.64815606011297,
    "y": 118.80555555555559
   },
   {
    "x": 418.31482272677965,
    "y": 116.47222222222226
   }
  ],
  [
   {
    "x": 428.42593383789074,
    "y": 118.02777777777781
   },
   {
    "x": 417.92593383789074,
    "y": 118.80555555555559
   },
   {
    "x": 422.5926005045574,
    "y": 115.69444444444449
   }
  ],
  [
   {
    "x": 428.42593383789074,
    "y": 116.86111111111114
   },
   {
    "x": 421.81482272677965,
    "y": 116.47222222222226
   },
   {
    "x": 425.7037116156685,
    "y": 112.58333333333337
   }
  ],
  [
   {
    "x": 430.3703782823352,
    "y": 115.69444444444449
   },
   {
    "x": 423.3703782823352,
    "y": 114.13888888888893
   },
   {
    "x": 429.2037116156685,
    "y": 110.25000000000003
   }
  ],
  [
   {
    "x": 433.8703782823352,
    "y": 114.52777777777781
   },
   {
    "x": 424.14815606011297,
    "y": 111.80555555555559
   },
   {
    "x": 429.2037116156685,
    "y": 109.08333333333337
   }
  ],
  [
   {
    "x": 436.2037116156685,
    "y": 109.08333333333337
   },
   {
    "x": 426.8703782823352,
    "y": 113.36111111111114
   },
   {
    "x": 431.14815606011297,
    "y": 108.30555555555559
   }
  ],
  [
   {
    "x": 424.5370449490019,
    "y": 105.19444444444447
   },
   {
    "x": 417.14815606011297,
    "y": 111.4166666666667
   },
   {
    "x": 425.31482272677965,
    "y": 108.30555555555559
   }
  ],
  [
   {
    "x": 450.3333333333335,
    "y": 78.75000000000003
   },
   {
    "x": 444.888888888889,
    "y": 84.19444444444447
   },
   {
    "x": 449.1666666666668,
    "y": 84.58333333333336
   }
  ],
  [
   {
    "x": 454.22222222222234,
    "y": 77.97222222222224
   },
   {
    "x": 448.7777777777779,
    "y": 81.08333333333336
   },
   {
    "x": 451.5000000000001,
    "y": 82.63888888888891
   }
  ],
  [
   {
    "x": 458.888888888889,
    "y": 78.36111111111113
   },
   {
    "x": 451.5000000000001,
    "y": 80.30555555555559
   },
   {
    "x": 455.388888888889,
    "y": 81.86111111111114
   }
  ],
  [
   {
    "x": 463.5555555555557,
    "y": 78.75000000000003
   },
   {
    "x": 456.1666666666668,
    "y": 80.30555555555559
   },
   {
    "x": 459.6666666666668,
    "y": 81.86111111111114
   }
  ],
  [
   {
    "x": 466.27777777777794,
    "y": 79.5277777777778
   },
   {
    "x": 459.6666666666668,
    "y": 80.69444444444447
   },
   {
    "x": 460.8333333333335,
    "y": 82.63888888888891
   }
  ],
  [
   {
    "x": 469.388888888889,
    "y": 82.63888888888891
   },
   {
    "x": 464.72222222222234,
    "y": 80.30555555555559
   },
   {
    "x": 464.72222222222234,
    "y": 83.41666666666669
   }
  ],
  [
   {
    "x": 470.5555555555557,
    "y": 86.13888888888891
   },
   {
    "x": 465.5000000000001,
    "y": 83.41666666666669
   },
   {
    "x": 464.72222222222234,
    "y": 86.13888888888891
   }
  ],
  [
   {
    "x": 471.3333333333335,
    "y": 89.25000000000003
   },
   {
    "x": 465.888888888889,
    "y": 83.41666666666669
   },
   {
    "x": 464.72222222222234,
    "y": 86.9166666666667
   }
  ],
  [
   {
    "x": 471.72222222222234,
    "y": 92.36111111111114
   },
   {
    "x": 465.5000000000001,
    "y": 85.75000000000003
   },
   {
    "x": 465.11111111111126,
    "y": 89.63888888888891
   }
  ],
  [
   {
    "x": 468.61111111111126,
    "y": 99.75000000000003
   },
   {
    "x": 466.6666666666668,
    "y": 87.30555555555559
   },
   {
    "x": 464.72222222222234,
    "y": 92.75000000000003
   }
  ],
  [
   {
    "x": 467.8333333333335,
    "y": 105.58333333333337
   },
   {
    "x": 466.27777777777794,
    "y": 95.08333333333336
   },
   {
    "x": 464.3333333333335,
    "y": 100.52777777777781
   }
  ],
  [
   {
    "x": 467.0555555555557,
    "y": 107.13888888888891
   },
   {
    "x": 465.5000000000001,
    "y": 101.30555555555559
   },
   {
    "x": 462.77777777777794,
    "y": 105.19444444444447
   }
  ],
  [
   {
    "x": 466.6666666666668,
    "y": 115.69444444444449
   },
   {
    "x": 463.94444444444457,
    "y": 102.47222222222226
   },
   {
    "x": 460.8333333333335,
    "y": 109.86111111111114
   }
  ],
  [
   {
    "x": 452.27777777777794,
    "y": 100.39815012613936
   },
   {
    "x": 448.388888888889,
    "y": 110.12037234836158
   },
   {
    "x": 452.6666666666668,
    "y": 106.23148345947268
   }
  ],
  [
   {
    "x": 448.7777777777779,
    "y": 106.62037234836157
   },
   {
    "x": 446.8333333333335,
    "y": 110.89815012613936
   },
   {
    "x": 451.11111111111126,
    "y": 110.12037234836158
   }
  ],
  [
   {
    "x": 438.2777777777779,
    "y": 112.06481679280603
   },
   {
    "x": 438.2777777777779,
    "y": 104.28703901502824
   },
   {
    "x": 440.61111111111126,
    "y": 105.06481679280603
   }
  ],
  [
   {
    "x": 439.44444444444457,
    "y": 115.56481679280603
   },
   {
    "x": 439.0555555555557,
    "y": 107.39815012613936
   },
   {
    "x": 442.94444444444457,
    "y": 107.39815012613936
   }
  ],
  [
   {
    "x": 442.1666666666668,
    "y": 117.89815012613936
   },
   {
    "x": 440.22222222222234,
    "y": 109.73148345947268
   },
   {
    "x": 443.3333333333335,
    "y": 112.45370568169491
   }
  ],
  [
   {
    "x": 444.888888888889,
    "y": 120.62037234836158
   },
   {
    "x": 441.7777777777779,
    "y": 113.23148345947268
   },
   {
    "x": 446.0555555555557,
    "y": 114.39815012613936
   }
  ],
  [
   {
    "x": 449.1666666666668,
    "y": 121.78703901502824
   },
   {
    "x": 444.5000000000001,
    "y": 114.78703901502824
   },
   {
    "x": 449.1666666666668,
    "y": 115.17592790391714
   }
  ],
  [
   {
    "x": 452.27777777777794,
    "y": 119.45370568169491
   },
   {
    "x": 445.2777777777779,
    "y": 117.50926123725047
   },
   {
    "x": 451.888888888889,
    "y": 114.78703901502824
   }
  ],
  [
   {
    "x": 453.31482272677965,
    "y": 120.75000000000004
   },
   {
    "x": 453.31482272677965,
    "y": 116.08333333333337
   },
   {
    "x": 456.0370449490019,
    "y": 121.52777777777781
   }
  ],
  [
   {
    "x": 453.70371161566857,
    "y": 125.02777777777781
   },
   {
    "x": 454.0926005045574,
    "y": 118.4166666666667
   },
   {
    "x": 456.81482272677965,
    "y": 125.02777777777781
   }
  ],
  [
   {
    "x": 454.0926005045574,
    "y": 133.97222222222226
   },
   {
    "x": 454.0926005045574,
    "y": 121.9166666666667
   },
   {
    "x": 455.64815606011297,
    "y": 122.30555555555559
   }
  ],
  [
   {
    "x": 454.8703782823352,
    "y": 137.08333333333337
   },
   {
    "x": 454.8703782823352,
    "y": 129.3055555555556
   },
   {
    "x": 457.20371161566857,
    "y": 130.08333333333337
   }
  ],
  [
   {
    "x": 457.98148939344634,
    "y": 142.13888888888894
   },
   {
    "x": 455.2592671712241,
    "y": 134.75000000000003
   },
   {
    "x": 457.5926005045574,
    "y": 134.75000000000003
   }
  ],
  [
   {
    "x": 460.70371161566857,
    "y": 144.47222222222226
   },
   {
    "x": 457.5926005045574,
    "y": 138.25000000000003
   },
   {
    "x": 462.64815606011297,
    "y": 140.19444444444449
   }
  ],
  [
   {
    "x": 466.92593383789074,
    "y": 146.02777777777783
   },
   {
    "x": 459.92593383789074,
    "y": 140.97222222222226
   },
   {
    "x": 465.7592671712241,
    "y": 139.8055555555556
   }
  ],
  [
   {
    "x": 470.81482272677965,
    "y": 142.52777777777783
   },
   {
    "x": 465.7592671712241,
    "y": 143.69444444444449
   },
   {
    "x": 469.2592671712241,
    "y": 137.08333333333337
   }
  ],
  [
   {
    "x": 479.3703782823352,
    "y": 132.4166666666667
   },
   {
    "x": 468.0926005045574,
    "y": 141.36111111111114
   },
   {
    "x": 469.64815606011297,
    "y": 134.36111111111114
   }
  ],
  [
   {
    "x": 478.5926005045574,
    "y": 128.9166666666667
   },
   {
    "x": 470.81482272677965,
    "y": 135.52777777777783
   },
   {
    "x": 471.98148939344634,
    "y": 129.3055555555556
   }
  ],
  [
   {
    "x": 479.3703782823352,
    "y": 124.25000000000004
   },
   {
    "x": 473.9259338378908,
    "y": 131.63888888888894
   },
   {
    "x": 473.9259338378908,
    "y": 127.36111111111114
   }
  ],
  [
   {
    "x": 479.7592671712241,
    "y": 119.58333333333337
   },
   {
    "x": 477.0370449490019,
    "y": 125.4166666666667
   },
   {
    "x": 477.0370449490019,
    "y": 118.4166666666667
   }
  ],
  [
   {
    "x": 483.2592671712241,
    "y": 117.63888888888893
   },
   {
    "x": 476.64815606011297,
    "y": 119.58333333333337
   },
   {
    "x": 478.20371161566857,
    "y": 115.69444444444449
   }
  ],
  [
   {
    "x": 482.0926005045574,
    "y": 114.13888888888893
   },
   {
    "x": 477.0370449490019,
    "y": 114.9166666666667
   },
   {
    "x": 477.4259338378908,
    "y": 113.36111111111114
   }
  ],
  [
   {
    "x": 484.4259338378908,
    "y": 107.13888888888891
   },
   {
    "x": 475.8703782823352,
    "y": 123.08333333333337
   },
   {
    "x": 479.7592671712241,
    "y": 108.30555555555559
   }
  ],
  [
   {
    "x": 468.48148939344634,
    "y": 121.52777777777781
   },
   {
    "x": 467.70371161566857,
    "y": 130.08333333333337
   },
   {
    "x": 470.42593383789074,
    "y": 122.69444444444449
   }
  ],
  [
   {
    "x": 470.0370449490019,
    "y": 114.13888888888893
   },
   {
    "x": 470.0370449490019,
    "y": 123.86111111111114
   },
   {
    "x": 474.70371161566857,
    "y": 115.69444444444449
   }
  ],
  [
   {
    "x": 473.5370449490019,
    "y": 107.9166666666667
   },
   {
    "x": 471.98148939344634,
    "y": 118.4166666666667
   },
   {
    "x": 477.0370449490019,
    "y": 109.08333333333337
   }
  ],
  [
   {
    "x": 479.50000000000017,
    "y": 88.99073876274959
   },
   {
    "x": 478.72222222222234,
    "y": 97.93518320719404
   },
   {
    "x": 482.61111111111126,
    "y": 90.15740542941626
   }
  ],
  [
   {
    "x": 480.27777777777794,
    "y": 84.71296098497182
   },
   {
    "x": 480.6666666666668,
    "y": 92.1018498738607
   },
   {
    "x": 484.1666666666668,
    "y": 86.65740542941626
   }
  ],
  [
   {
    "x": 481.0555555555557,
    "y": 81.6018498738607
   },
   {
    "x": 481.8333333333335,
    "y": 90.54629431830514
   },
   {
    "x": 484.1666666666668,
    "y": 87.82407209608293
   }
  ],
  [
   {
    "x": 484.1666666666668,
    "y": 77.71296098497182
   },
   {
    "x": 481.8333333333335,
    "y": 83.93518320719403
   },
   {
    "x": 485.3333333333335,
    "y": 84.71296098497182
   }
  ],
  [
   {
    "x": 489.61111111111126,
    "y": 72.26851654052737
   },
   {
    "x": 484.5555555555557,
    "y": 79.26851654052737
   },
   {
    "x": 491.5555555555557,
    "y": 77.71296098497182
   }
  ],
  [
   {
    "x": 492.7222222222224,
    "y": 69.54629431830514
   },
   {
    "x": 488.0555555555557,
    "y": 76.93518320719403
   },
   {
    "x": 493.11111111111126,
    "y": 76.15740542941626
   }
  ],
  [
   {
    "x": 496.61111111111126,
    "y": 68.76851654052736
   },
   {
    "x": 491.1666666666668,
    "y": 74.6018498738607
   },
   {
    "x": 496.2222222222224,
    "y": 73.43518320719403
   }
  ],
  [
   {
    "x": 502.0555555555557,
    "y": 66.82407209608292
   },
   {
    "x": 494.6666666666668,
    "y": 71.49073876274959
   },
   {
    "x": 498.5555555555557,
    "y": 72.26851654052737
   }
  ],
  [
   {
    "x": 510.61111111111126,
    "y": 67.21296098497182
   },
   {
    "x": 500.888888888889,
    "y": 69.15740542941626
   },
   {
    "x": 503.2222222222224,
    "y": 74.6018498738607
   }
  ],
  [
   {
    "x": 516.0555555555557,
    "y": 73.17592790391713
   },
   {
    "x": 508.6666666666668,
    "y": 69.67592790391713
   },
   {
    "x": 507.888888888889,
    "y": 72.00926123725046
   }
  ],
  [
   {
    "x": 517.2222222222224,
    "y": 79.78703901502824
   },
   {
    "x": 511.388888888889,
    "y": 72.00926123725046
   },
   {
    "x": 509.8333333333335,
    "y": 73.56481679280601
   }
  ],
  [
   {
    "x": 516.4444444444446,
    "y": 76.28703901502824
   },
   {
    "x": 510.61111111111126,
    "y": 73.56481679280601
   },
   {
    "x": 509.8333333333335,
    "y": 75.50926123725046
   }
  ],
  [
   {
    "x": 518.388888888889,
    "y": 83.67592790391713
   },
   {
    "x": 512.1666666666669,
    "y": 75.12037234836157
   },
   {
    "x": 510.61111111111126,
    "y": 76.28703901502824
   }
  ],
  [
   {
    "x": 511.77777777777794,
    "y": 81.73148345947268
   },
   {
    "x": 512.9444444444446,
    "y": 76.67592790391713
   },
   {
    "x": 511.388888888889,
    "y": 76.67592790391713
   }
  ],
  [
   {
    "x": 508.27777777777794,
    "y": 84.06481679280601
   },
   {
    "x": 512.1666666666669,
    "y": 77.84259457058378
   },
   {
    "x": 509.0555555555557,
    "y": 77.06481679280601
   }
  ],
  [
   {
    "x": 505.1666666666668,
    "y": 84.4537056816949
   },
   {
    "x": 509.8333333333335,
    "y": 79.39815012613934
   },
   {
    "x": 505.5555555555557,
    "y": 78.23148345947268
   }
  ],
  [
   {
    "x": 488.0555555555557,
    "y": 100.00926123725047
   },
   {
    "x": 484.5555555555557,
    "y": 101.95370568169491
   },
   {
    "x": 485.72222222222234,
    "y": 98.45370568169491
   }
  ],
  [
   {
    "x": 495.0555555555557,
    "y": 101.17592790391713
   },
   {
    "x": 488.44444444444457,
    "y": 96.12037234836157
   },
   {
    "x": 492.7222222222224,
    "y": 94.17592790391713
   }
  ],
  [
   {
    "x": 500.11111111111126,
    "y": 101.56481679280601
   },
   {
    "x": 491.1666666666668,
    "y": 96.89815012613936
   },
   {
    "x": 496.2222222222224,
    "y": 95.3425945705838
   }
  ],
  [
   {
    "x": 505.1666666666668,
    "y": 102.73148345947268
   },
   {
    "x": 495.8333333333335,
    "y": 97.67592790391713
   },
   {
    "x": 501.27777777777794,
    "y": 95.73148345947268
   }
  ],
  [
   {
    "x": 497.77777777777794,
    "y": 88.73148345947268
   },
   {
    "x": 492.7222222222224,
    "y": 88.73148345947268
   },
   {
    "x": 493.11111111111126,
    "y": 89.89815012613936
   }
  ],
  [
   {
    "x": 499.3333333333335,
    "y": 89.89815012613936
   },
   {
    "x": 494.6666666666668,
    "y": 89.50926123725046
   },
   {
    "x": 496.2222222222224,
    "y": 90.67592790391713
   }
  ],
  [
   {
    "x": 502.44444444444457,
    "y": 89.89815012613936
   },
   {
    "x": 498.1666666666668,
    "y": 90.28703901502824
   },
   {
    "x": 500.50000000000017,
    "y": 91.8425945705838
   }
  ],
  [
   {
    "x": 507.50000000000017,
    "y": 90.28703901502824
   },
   {
    "x": 500.50000000000017,
    "y": 90.67592790391713
   },
   {
    "x": 504.00000000000017,
    "y": 92.62037234836157
   }
  ],
  [
   {
    "x": 511.77777777777794,
    "y": 90.67592790391713
   },
   {
    "x": 502.8333333333335,
    "y": 91.8425945705838
   },
   {
    "x": 505.5555555555557,
    "y": 93.78703901502824
   }
  ],
  [
   {
    "x": 512.1666666666669,
    "y": 92.62037234836157
   },
   {
    "x": 503.2222222222224,
    "y": 92.62037234836157
   },
   {
    "x": 505.1666666666668,
    "y": 94.17592790391713
   }
  ],
  [
   {
    "x": 514.1111111111113,
    "y": 94.17592790391713
   },
   {
    "x": 509.0555555555557,
    "y": 94.95370568169491
   },
   {
    "x": 509.8333333333335,
    "y": 96.12037234836157
   }
  ],
  [
   {
    "x": 512.9444444444446,
    "y": 93.39815012613936
   },
   {
    "x": 508.27777777777794,
    "y": 93.39815012613936
   },
   {
    "x": 509.0555555555557,
    "y": 94.56481679280601
   }
  ],
  [
   {
    "x": 514.5000000000001,
    "y": 95.3425945705838
   },
   {
    "x": 511.00000000000017,
    "y": 94.95370568169491
   },
   {
    "x": 512.5555555555557,
    "y": 97.67592790391713
   }
  ],
  [
   {
    "x": 518.0000000000001,
    "y": 98.06481679280601
   },
   {
    "x": 512.1666666666669,
    "y": 95.73148345947268
   },
   {
    "x": 515.6666666666669,
    "y": 100.39815012613936
   }
  ],
  [
   {
    "x": 527.2037116156686,
    "y": 130.9907387627496
   },
   {
    "x": 525.2592671712241,
    "y": 121.65740542941627
   },
   {
    "x": 522.5370449490019,
    "y": 126.32407209608294
   }
  ],
  [
   {
    "x": 526.4259338378907,
    "y": 137.60184987386071
   },
   {
    "x": 524.8703782823352,
    "y": 126.71296098497183
   },
   {
    "x": 522.5370449490019,
    "y": 130.21296098497183
   }
  ],
  [
   {
    "x": 524.4814893934464,
    "y": 143.43518320719406
   },
   {
    "x": 524.4814893934464,
    "y": 132.1574054294163
   },
   {
    "x": 520.5926005045575,
    "y": 137.9907387627496
   }
  ],
  [
   {
    "x": 522.5370449490019,
    "y": 148.10184987386071
   },
   {
    "x": 522.9259338378907,
    "y": 136.82407209608294
   },
   {
    "x": 519.0370449490019,
    "y": 142.6574054294163
   }
  ],
  [
   {
    "x": 519.8148227267797,
    "y": 153.93518320719406
   },
   {
    "x": 521.7592671712241,
    "y": 141.8796276516385
   },
   {
    "x": 518.2592671712241,
    "y": 143.04629431830517
   }
  ],
  [
   {
    "x": 514.3703782823352,
    "y": 160.54629431830517
   },
   {
    "x": 519.8148227267797,
    "y": 144.9907387627496
   },
   {
    "x": 513.5926005045575,
    "y": 151.21296098497183
   }
  ],
  [
   {
    "x": 511.2592671712241,
    "y": 162.49073876274963
   },
   {
    "x": 515.148156060113,
    "y": 153.1574054294163
   },
   {
    "x": 507.7592671712241,
    "y": 158.21296098497183
   }
  ],
  [
   {
    "x": 508.9259338378908,
    "y": 165.21296098497183
   },
   {
    "x": 512.0370449490019,
    "y": 157.82407209608294
   },
   {
    "x": 506.5926005045574,
    "y": 158.21296098497183
   }
  ],
  [
   {
    "x": 506.20371161566857,
    "y": 166.7685165405274
   },
   {
    "x": 509.31482272677965,
    "y": 160.1574054294163
   },
   {
    "x": 504.2592671712241,
    "y": 159.7685165405274
   }
  ],
  [
   {
    "x": 502.31482272677965,
    "y": 167.93518320719406
   },
   {
    "x": 508.5370449490019,
    "y": 161.71296098497183
   },
   {
    "x": 501.9259338378908,
    "y": 162.10184987386071
   }
  ],
  [
   {
    "x": 494.148156060113,
    "y": 171.82407209608294
   },
   {
    "x": 506.5926005045574,
    "y": 164.04629431830517
   },
   {
    "x": 497.2592671712241,
    "y": 164.43518320719406
   }
  ],
  [
   {
    "x": 482.8703782823352,
    "y": 169.87962765163851
   },
   {
    "x": 496.0926005045574,
    "y": 168.32407209608294
   },
   {
    "x": 492.98148939344634,
    "y": 165.60184987386071
   }
  ],
  [
   {
    "x": 471.20371161566857,
    "y": 164.43518320719406
   },
   {
    "x": 489.48148939344634,
    "y": 167.1574054294163
   },
   {
    "x": 487.9259338378908,
    "y": 163.6574054294163
   }
  ],
  [
   {
    "x": 462.2592671712241,
    "y": 158.60184987386071
   },
   {
    "x": 482.8703782823352,
    "y": 163.6574054294163
   },
   {
    "x": 482.8703782823352,
    "y": 161.71296098497183
   }
  ],
  [
   {
    "x": 461.8703782823352,
    "y": 155.4907387627496
   },
   {
    "x": 483.2592671712241,
    "y": 160.54629431830517
   },
   {
    "x": 483.64815606011297,
    "y": 158.60184987386071
   }
  ],
  [
   {
    "x": 473.5370449490019,
    "y": 153.1574054294163
   },
   {
    "x": 484.4259338378908,
    "y": 164.43518320719406
   },
   {
    "x": 485.5926005045574,
    "y": 162.87962765163851
   }
  ],
  [
   {
    "x": 472.3703782823352,
    "y": 149.6574054294163
   },
   {
    "x": 484.0370449490019,
    "y": 161.71296098497183
   },
   {
    "x": 484.81482272677965,
    "y": 160.1574054294163
   }
  ],
  [
   {
    "x": 473.9259338378908,
    "y": 142.6574054294163
   },
   {
    "x": 477.81482272677965,
    "y": 153.93518320719406
   },
   {
    "x": 480.9259338378908,
    "y": 152.37962765163851
   }
  ],
  [
   {
    "x": 478.98148939344634,
    "y": 141.10184987386071
   },
   {
    "x": 478.98148939344634,
    "y": 152.7685165405274
   },
   {
    "x": 481.31482272677965,
    "y": 152.7685165405274
   }
  ],
  [
   {
    "x": 480.5370449490019,
    "y": 130.60184987386071
   },
   {
    "x": 480.14815606011297,
    "y": 144.21296098497183
   },
   {
    "x": 483.2592671712241,
    "y": 144.21296098497183
   }
  ],
  [
   {
    "x": 484.81482272677965,
    "y": 129.82407209608294
   },
   {
    "x": 482.0926005045574,
    "y": 141.10184987386071
   },
   {
    "x": 485.20371161566857,
    "y": 141.10184987386071
   }
  ],
  [
   {
    "x": 485.98148939344634,
    "y": 132.93518320719406
   },
   {
    "x": 484.4259338378908,
    "y": 137.9907387627496
   },
   {
    "x": 486.7592671712241,
    "y": 137.9907387627496
   }
  ],
  [
   {
    "x": 488.70371161566857,
    "y": 128.26851654052737
   },
   {
    "x": 485.5926005045574,
    "y": 135.26851654052737
   },
   {
    "x": 487.5370449490019,
    "y": 135.26851654052737
   }
  ],
  [
   {
    "x": 490.64815606011297,
    "y": 155.4907387627496
   },
   {
    "x": 490.64815606011297,
    "y": 158.60184987386071
   },
   {
    "x": 488.70371161566857,
    "y": 157.04629431830517
   }
  ],
  [
   {
    "x": 491.4259338378908,
    "y": 151.9907387627496
   },
   {
    "x": 488.31482272677965,
    "y": 156.6574054294163
   },
   {
    "x": 488.31482272677965,
    "y": 151.9907387627496
   }
  ],
  [
   {
    "x": 492.5926005045574,
    "y": 148.4907387627496
   },
   {
    "x": 489.0926005045574,
    "y": 151.9907387627496
   },
   {
    "x": 489.0926005045574,
    "y": 147.71296098497183
   }
  ],
  [
   {
    "x": 494.148156060113,
    "y": 143.04629431830517
   },
   {
    "x": 489.8703782823352,
    "y": 148.8796276516385
   },
   {
    "x": 490.2592671712241,
    "y": 143.43518320719406
   }
  ],
  [
   {
    "x": 495.31482272677965,
    "y": 138.76851654052737
   },
   {
    "x": 490.2592671712241,
    "y": 145.3796276516385
   },
   {
    "x": 492.20371161566857,
    "y": 138.76851654052737
   }
  ],
  [
   {
    "x": 498.0370449490019,
    "y": 134.8796276516385
   },
   {
    "x": 492.20371161566857,
    "y": 139.54629431830517
   },
   {
    "x": 492.98148939344634,
    "y": 134.8796276516385
   }
  ],
  [
   {
    "x": 502.31482272677965,
    "y": 130.60184987386071
   },
   {
    "x": 494.9259338378908,
    "y": 135.26851654052737
   },
   {
    "x": 496.48148939344634,
    "y": 130.60184987386071
   }
  ],
  [
   {
    "x": 503.48148939344634,
    "y": 128.26851654052737
   },
   {
    "x": 496.0926005045574,
    "y": 132.54629431830517
   },
   {
    "x": 496.8703782823352,
    "y": 127.87962765163849
   }
  ],
  [
   {
    "x": 505.0370449490019,
    "y": 125.15740542941627
   },
   {
    "x": 496.8703782823352,
    "y": 130.21296098497183
   },
   {
    "x": 501.5370449490019,
    "y": 121.65740542941627
   }
  ],
  [
   {
    "x": 509.31482272677965,
    "y": 121.65740542941627
   },
   {
    "x": 499.5926005045574,
    "y": 126.71296098497183
   },
   {
    "x": 505.0370449490019,
    "y": 118.15740542941627
   }
  ],
  [
   {
    "x": 513.2037116156686,
    "y": 116.21296098497183
   },
   {
    "x": 503.0926005045574,
    "y": 122.43518320719404
   },
   {
    "x": 506.5926005045574,
    "y": 115.43518320719404
   }
  ],
  [
   {
    "x": 527.8518676757814,
    "y": 90.0277777777778
   },
   {
    "x": 522.4074232313369,
    "y": 97.02777777777781
   },
   {
    "x": 529.407423231337,
    "y": 94.69444444444447
   }
  ],
  [
   {
    "x": 530.5740898980036,
    "y": 84.19444444444447
   },
   {
    "x": 527.8518676757814,
    "y": 94.69444444444447
   },
   {
    "x": 530.9629787868926,
    "y": 93.9166666666667
   }
  ],
  [
   {
    "x": 532.907423231337,
    "y": 81.86111111111114
   },
   {
    "x": 530.1852010091147,
    "y": 92.36111111111114
   },
   {
    "x": 534.4629787868926,
    "y": 90.4166666666667
   }
  ],
  [
   {
    "x": 535.2407565646703,
    "y": 70.97222222222224
   },
   {
    "x": 533.2963121202258,
    "y": 90.0277777777778
   },
   {
    "x": 539.5185343424481,
    "y": 85.75000000000003
   }
  ],
  [
   {
    "x": 537.1852010091147,
    "y": 65.5277777777778
   },
   {
    "x": 536.7963121202258,
    "y": 80.69444444444447
   },
   {
    "x": 541.0740898980036,
    "y": 78.36111111111113
   }
  ],
  [
   {
    "x": 534.4629787868926,
    "y": 60.47222222222224
   },
   {
    "x": 522.4074232313369,
    "y": 62.0277777777778
   },
   {
    "x": 525.1296454535592,
    "y": 58.13888888888891
   }
  ],
  [
   {
    "x": 524.3518676757814,
    "y": 63.58333333333335
   },
   {
    "x": 513.0740898980036,
    "y": 63.194444444444464
   },
   {
    "x": 521.2407565646703,
    "y": 56.97222222222224
   }
  ],
  [
   {
    "x": 518.1296454535592,
    "y": 65.91666666666669
   },
   {
    "x": 505.68520100911473,
    "y": 65.13888888888891
   },
   {
    "x": 511.90742323133696,
    "y": 58.916666666666686
   }
  ],
  [
   {
    "x": 508.40742323133696,
    "y": 66.69444444444447
   },
   {
    "x": 490.51853434244805,
    "y": 64.75000000000001
   },
   {
    "x": 504.90742323133696,
    "y": 60.86111111111113
   }
  ],
  [
   {
    "x": 475.3518676757814,
    "y": 48.80555555555557
   },
   {
    "x": 479.6296454535592,
    "y": 59.30555555555557
   },
   {
    "x": 481.9629787868925,
    "y": 58.52777777777779
   }
  ],
  [
   {
    "x": 474.9629787868925,
    "y": 45.69444444444446
   },
   {
    "x": 478.8518676757814,
    "y": 56.194444444444464
   },
   {
    "x": 480.7963121202258,
    "y": 54.63888888888891
   }
  ],
  [
   {
    "x": 476.51853434244805,
    "y": 41.41666666666668
   },
   {
    "x": 478.4629787868925,
    "y": 53.472222222222236
   },
   {
    "x": 480.7963121202258,
    "y": 52.69444444444446
   }
  ],
  [
   {
    "x": 478.8518676757814,
    "y": 39.472222222222236
   },
   {
    "x": 478.4629787868925,
    "y": 48.80555555555557
   },
   {
    "x": 480.7963121202258,
    "y": 48.80555555555557
   }
  ],
  [
   {
    "x": 484.68520100911473,
    "y": 42.58333333333334
   },
   {
    "x": 479.2407565646703,
    "y": 44.91666666666668
   },
   {
    "x": 481.5740898980036,
    "y": 48.02777777777779
   }
  ],
  [
   {
    "x": 487.7963121202258,
    "y": 44.52777777777779
   },
   {
    "x": 480.7963121202258,
    "y": 46.08333333333335
   },
   {
    "x": 482.7407565646703,
    "y": 49.972222222222236
   }
  ],
  [
   {
    "x": 488.18520100911473,
    "y": 48.02777777777779
   },
   {
    "x": 481.5740898980036,
    "y": 48.02777777777779
   },
   {
    "x": 483.1296454535592,
    "y": 51.52777777777779
   }
  ],
  [
   {
    "x": 493.6296454535592,
    "y": 50.750000000000014
   },
   {
    "x": 484.68520100911473,
    "y": 49.972222222222236
   },
   {
    "x": 485.8518676757814,
    "y": 52.30555555555557
   }
  ],
  [
   {
    "x": 498.2963121202258,
    "y": 51.13888888888891
   },
   {
    "x": 488.5740898980036,
    "y": 52.30555555555557
   },
   {
    "x": 489.3518676757814,
    "y": 54.63888888888891
   }
  ],
  [
   {
    "x": 509.18520100911473,
    "y": 51.13888888888891
   },
   {
    "x": 494.40742323133696,
    "y": 52.69444444444446
   },
   {
    "x": 497.90742323133696,
    "y": 56.194444444444464
   }
  ],
  [
   {
    "x": 520.8518676757814,
    "y": 51.13888888888891
   },
   {
    "x": 504.51853434244805,
    "y": 53.08333333333335
   },
   {
    "x": 512.6852010091147,
    "y": 55.02777777777779
   }
  ],
  [
   {
    "x": 606.7963121202258,
    "y": 39.53703901502822
   },
   {
    "x": 597.8518676757815,
    "y": 43.42592790391711
   },
   {
    "x": 604.8518676757815,
    "y": 44.20370568169489
   }
  ],
  [
   {
    "x": 612.6296454535592,
    "y": 40.314816792806
   },
   {
    "x": 603.2963121202258,
    "y": 43.03703901502823
   },
   {
    "x": 610.6852010091147,
    "y": 44.20370568169489
   }
  ],
  [
   {
    "x": 619.6296454535592,
    "y": 39.148150126139335
   },
   {
    "x": 610.2963121202259,
    "y": 43.42592790391711
   },
   {
    "x": 617.2963121202259,
    "y": 43.42592790391711
   }
  ],
  [
   {
    "x": 633.6296454535592,
    "y": 38.370372348361556
   },
   {
    "x": 617.2963121202259,
    "y": 41.48148345947267
   },
   {
    "x": 625.4629787868926,
    "y": 43.814816792806006
   }
  ],
  [
   {
    "x": 638.2963121202259,
    "y": 39.148150126139335
   },
   {
    "x": 626.6296454535592,
    "y": 41.870372348361556
   },
   {
    "x": 634.0185343424481,
    "y": 43.42592790391711
   }
  ],
  [
   {
    "x": 642.5740898980036,
    "y": 38.75926123725045
   },
   {
    "x": 634.407423231337,
    "y": 41.48148345947267
   },
   {
    "x": 639.8518676757815,
    "y": 43.42592790391711
   }
  ],
  [
   {
    "x": 648.407423231337,
    "y": 39.148150126139335
   },
   {
    "x": 638.6852010091147,
    "y": 41.48148345947267
   },
   {
    "x": 644.5185343424481,
    "y": 42.648150126139335
   }
  ],
  [
   {
    "x": 650.7407565646704,
    "y": 40.314816792806
   },
   {
    "x": 644.1296454535592,
    "y": 41.870372348361556
   },
   {
    "x": 650.7407565646704,
    "y": 43.814816792806006
   }
  ],
  [
   {
    "x": 655.407423231337,
    "y": 39.53703901502822
   },
   {
    "x": 649.5740898980036,
    "y": 42.648150126139335
   },
   {
    "x": 653.8518676757815,
    "y": 43.814816792806006
   }
  ],
  [
   {
    "x": 658.907423231337,
    "y": 41.870372348361556
   },
   {
    "x": 650.7407565646704,
    "y": 42.648150126139335
   },
   {
    "x": 657.7407565646704,
    "y": 44.98148345947267
   }
  ],
  [
   {
    "x": 663.9629787868926,
    "y": 43.42592790391711
   },
   {
    "x": 656.5740898980036,
    "y": 43.42592790391711
   },
   {
    "x": 658.907423231337,
    "y": 46.148150126139335
   }
  ],
  [
   {
    "x": 668.2407565646704,
    "y": 44.20370568169489
   },
   {
    "x": 657.7407565646704,
    "y": 43.814816792806006
   },
   {
    "x": 659.2963121202259,
    "y": 46.148150126139335
   }
  ],
  [
   {
    "x": 677.9629787868926,
    "y": 49.77777777777779
   },
   {
    "x": 664.3518676757815,
    "y": 44.722222222222236
   },
   {
    "x": 663.5740898980036,
    "y": 47.05555555555557
   }
  ],
  [
   {
    "x": 678.7407565646704,
    "y": 52.500000000000014
   },
   {
    "x": 667.8518676757815,
    "y": 49.000000000000014
   },
   {
    "x": 667.8518676757815,
    "y": 50.16666666666668
   }
  ],
  [
   {
    "x": 680.2963121202259,
    "y": 58.33333333333335
   },
   {
    "x": 670.5740898980036,
    "y": 48.61111111111113
   },
   {
    "x": 667.8518676757815,
    "y": 50.55555555555557
   }
  ],
  [
   {
    "x": 680.6852010091147,
    "y": 61.444444444444464
   },
   {
    "x": 669.7963121202259,
    "y": 49.77777777777779
   },
   {
    "x": 669.7963121202259,
    "y": 53.666666666666686
   }
  ],
  [
   {
    "x": 675.2407565646704,
    "y": 63.7777777777778
   },
   {
    "x": 672.1296454535592,
    "y": 54.05555555555557
   },
   {
    "x": 670.5740898980036,
    "y": 56.000000000000014
   }
  ],
  [
   {
    "x": 673.6852010091147,
    "y": 67.66666666666669
   },
   {
    "x": 672.1296454535592,
    "y": 57.55555555555557
   },
   {
    "x": 670.5740898980036,
    "y": 59.11111111111113
   }
  ],
  [
   {
    "x": 668.2407565646704,
    "y": 69.61111111111113
   },
   {
    "x": 672.1296454535592,
    "y": 61.444444444444464
   },
   {
    "x": 668.6296454535592,
    "y": 62.22222222222224
   }
  ],
  [
   {
    "x": 663.5740898980036,
    "y": 70.7777777777778
   },
   {
    "x": 670.5740898980036,
    "y": 64.55555555555557
   },
   {
    "x": 666.6852010091147,
    "y": 63.38888888888891
   }
  ],
  [
   {
    "x": 657.3518676757815,
    "y": 69.22222222222224
   },
   {
    "x": 666.6852010091147,
    "y": 66.50000000000001
   },
   {
    "x": 662.7963121202259,
    "y": 63.38888888888891
   }
  ],
  [
   {
    "x": 653.8518676757815,
    "y": 67.66666666666669
   },
   {
    "x": 662.7963121202259,
    "y": 66.88888888888891
   },
   {
    "x": 662.0185343424481,
    "y": 64.94444444444446
   }
  ],
  [
   {
    "x": 656.5740898980036,
    "y": 65.72222222222224
   },
   {
    "x": 662.407423231337,
    "y": 64.94444444444446
   },
   {
    "x": 659.2963121202259,
    "y": 62.61111111111113
   }
  ],
  [
   {
    "x": 653.0740898980036,
    "y": 64.16666666666669
   },
   {
    "x": 657.7407565646704,
    "y": 61.83333333333335
   },
   {
    "x": 660.8518676757815,
    "y": 64.16666666666669
   }
  ],
  [
   {
    "x": 666.6852010091147,
    "y": 56.77777777777779
   },
   {
    "x": 659.6852010091147,
    "y": 50.94444444444446
   },
   {
    "x": 667.8518676757815,
    "y": 53.666666666666686
   }
  ],
  [
   {
    "x": 660.8518676757815,
    "y": 53.27777777777779
   },
   {
    "x": 651.5185343424481,
    "y": 48.61111111111113
   },
   {
    "x": 660.4629787868926,
    "y": 49.38888888888891
   }
  ],
  [
   {
    "x": 655.0185343424481,
    "y": 52.500000000000014
   },
   {
    "x": 643.7407565646703,
    "y": 47.44444444444446
   },
   {
    "x": 651.5185343424481,
    "y": 47.05555555555557
   }
  ],
  [
   {
    "x": 650.7407565646704,
    "y": 51.722222222222236
   },
   {
    "x": 636.7407565646703,
    "y": 48.61111111111113
   },
   {
    "x": 646.0740898980036,
    "y": 45.8888888888889
   }
  ],
  [
   {
    "x": 641.7963121202259,
    "y": 51.722222222222236
   },
   {
    "x": 625.8518676757815,
    "y": 49.38888888888891
   },
   {
    "x": 634.407423231337,
    "y": 44.722222222222236
   }
  ],
  [
   {
    "x": 549.5000000000001,
    "y": 81.08333333333336
   },
   {
    "x": 545.6111111111113,
    "y": 91.58333333333336
   },
   {
    "x": 544.4444444444446,
    "y": 85.75000000000003
   }
  ],
  [
   {
    "x": 549.1111111111113,
    "y": 86.5277777777778
   },
   {
    "x": 544.8333333333335,
    "y": 96.63888888888891
   },
   {
    "x": 543.2777777777779,
    "y": 90.0277777777778
   }
  ],
  [
   {
    "x": 549.888888888889,
    "y": 90.4166666666667
   },
   {
    "x": 543.6666666666669,
    "y": 103.25000000000003
   },
   {
    "x": 543.2777777777779,
    "y": 92.36111111111114
   }
  ],
  [
   {
    "x": 547.9444444444446,
    "y": 99.75000000000003
   },
   {
    "x": 542.888888888889,
    "y": 106.75000000000003
   },
   {
    "x": 542.1111111111113,
    "y": 99.75000000000003
   }
  ],
  [
   {
    "x": 547.9444444444446,
    "y": 103.63888888888891
   },
   {
    "x": 539.7777777777779,
    "y": 118.02777777777781
   },
   {
    "x": 540.1666666666669,
    "y": 104.02777777777781
   }
  ],
  [
   {
    "x": 544.8333333333335,
    "y": 111.02777777777781
   },
   {
    "x": 539.0000000000001,
    "y": 116.08333333333337
   },
   {
    "x": 540.5555555555558,
    "y": 109.47222222222226
   }
  ],
  [
   {
    "x": 546.0000000000001,
    "y": 114.52777777777781
   },
   {
    "x": 539.7777777777779,
    "y": 122.30555555555559
   },
   {
    "x": 541.3333333333335,
    "y": 112.58333333333337
   }
  ],
  [
   {
    "x": 522.9259101019967,
    "y": 165.86111111111117
   },
   {
    "x": 525.2592434353301,
    "y": 154.19444444444449
   },
   {
    "x": 527.2036878797745,
    "y": 156.9166666666667
   }
  ],
  [
   {
    "x": 523.7036878797744,
    "y": 169.75000000000006
   },
   {
    "x": 525.6481323242189,
    "y": 160.4166666666667
   },
   {
    "x": 527.5925767686633,
    "y": 162.75000000000006
   }
  ],
  [
   {
    "x": 524.0925767686633,
    "y": 174.02777777777783
   },
   {
    "x": 525.2592434353301,
    "y": 165.47222222222229
   },
   {
    "x": 527.5925767686633,
    "y": 166.63888888888894
   }
  ],
  [
   {
    "x": 524.8703545464411,
    "y": 177.52777777777783
   },
   {
    "x": 526.4259101019967,
    "y": 168.19444444444449
   },
   {
    "x": 529.1481323242189,
    "y": 169.75000000000006
   }
  ],
  [
   {
    "x": 529.9259101019967,
    "y": 183.36111111111117
   },
   {
    "x": 527.2036878797745,
    "y": 172.86111111111117
   },
   {
    "x": 530.7036878797745,
    "y": 173.63888888888894
   }
  ],
  [
   {
    "x": 541.5925767686633,
    "y": 191.52777777777783
   },
   {
    "x": 529.9259101019967,
    "y": 177.9166666666667
   },
   {
    "x": 533.8147989908856,
    "y": 175.19444444444449
   }
  ],
  [
   {
    "x": 540.8147989908856,
    "y": 187.63888888888894
   },
   {
    "x": 533.0370212131078,
    "y": 178.3055555555556
   },
   {
    "x": 535.3703545464411,
    "y": 176.75000000000006
   }
  ],
  [
   {
    "x": 554.0370212131078,
    "y": 182.97222222222229
   },
   {
    "x": 536.5370212131078,
    "y": 181.4166666666667
   },
   {
    "x": 538.4814656575522,
    "y": 176.75000000000006
   }
  ],
  [
   {
    "x": 552.8703545464411,
    "y": 179.0833333333334
   },
   {
    "x": 540.4259101019967,
    "y": 178.3055555555556
   },
   {
    "x": 541.2036878797745,
    "y": 175.97222222222229
   }
  ],
  [
   {
    "x": 552.8703545464411,
    "y": 174.4166666666667
   },
   {
    "x": 541.9814656575522,
    "y": 179.0833333333334
   },
   {
    "x": 541.9814656575522,
    "y": 174.02777777777783
   }
  ],
  [
   {
    "x": 555.2036878797745,
    "y": 168.19444444444449
   },
   {
    "x": 543.9259101019967,
    "y": 174.4166666666667
   },
   {
    "x": 546.2592434353301,
    "y": 165.86111111111117
   }
  ],
  [
   {
    "x": 554.4259101019967,
    "y": 164.69444444444449
   },
   {
    "x": 546.6481323242189,
    "y": 168.58333333333337
   },
   {
    "x": 547.8147989908856,
    "y": 163.52777777777783
   }
  ],
  [
   {
    "x": 559.0925767686633,
    "y": 157.3055555555556
   },
   {
    "x": 550.1481323242189,
    "y": 167.4166666666667
   },
   {
    "x": 548.2036878797745,
    "y": 163.9166666666667
   }
  ],
  [
   {
    "x": 558.3147989908856,
    "y": 153.8055555555556
   },
   {
    "x": 550.9259101019967,
    "y": 161.97222222222226
   },
   {
    "x": 550.5370212131078,
    "y": 157.69444444444449
   }
  ],
  [
   {
    "x": 560.6481323242189,
    "y": 146.02777777777783
   },
   {
    "x": 550.1481323242189,
    "y": 161.97222222222226
   },
   {
    "x": 552.0925767686633,
    "y": 150.3055555555556
   }
  ],
  [
   {
    "x": 561.8147989908856,
    "y": 139.4166666666667
   },
   {
    "x": 552.8703545464411,
    "y": 154.97222222222226
   },
   {
    "x": 554.8147989908856,
    "y": 141.36111111111114
   }
  ],
  [
   {
    "x": 562.5925767686633,
    "y": 133.19444444444449
   },
   {
    "x": 556.3703545464411,
    "y": 140.97222222222226
   },
   {
    "x": 558.3147989908856,
    "y": 132.4166666666667
   }
  ],
  [
   {
    "x": 567.0000000000002,
    "y": 118.28703901502824
   },
   {
    "x": 563.888888888889,
    "y": 120.62037234836158
   },
   {
    "x": 564.6666666666669,
    "y": 114.78703901502824
   }
  ],
  [
   {
    "x": 567.7777777777779,
    "y": 114.78703901502824
   },
   {
    "x": 564.6666666666669,
    "y": 118.28703901502824
   },
   {
    "x": 564.6666666666669,
    "y": 112.8425945705838
   }
  ],
  [
   {
    "x": 569.7222222222224,
    "y": 110.50926123725047
   },
   {
    "x": 565.4444444444446,
    "y": 115.56481679280603
   },
   {
    "x": 567.7777777777779,
    "y": 108.56481679280603
   }
  ],
  [
   {
    "x": 572.8333333333335,
    "y": 105.06481679280603
   },
   {
    "x": 567.0000000000002,
    "y": 111.28703901502824
   },
   {
    "x": 568.9444444444446,
    "y": 103.89815012613936
   }
  ],
  [
   {
    "x": 575.5555555555558,
    "y": 98.8425945705838
   },
   {
    "x": 569.3333333333335,
    "y": 106.23148345947268
   },
   {
    "x": 572.4444444444446,
    "y": 96.89815012613936
   }
  ],
  [
   {
    "x": 578.2777777777779,
    "y": 93.39815012613936
   },
   {
    "x": 570.888888888889,
    "y": 101.17592790391713
   },
   {
    "x": 575.1666666666669,
    "y": 91.8425945705838
   }
  ],
  [
   {
    "x": 578.6666666666669,
    "y": 88.73148345947268
   },
   {
    "x": 575.5555555555558,
    "y": 93.78703901502824
   },
   {
    "x": 576.7222222222224,
    "y": 87.9537056816949
   }
  ],
  [
   {
    "x": 565.8333333333335,
    "y": 97.28703901502824
   },
   {
    "x": 562.7222222222224,
    "y": 108.95370568169491
   },
   {
    "x": 567.0000000000002,
    "y": 103.50926123725047
   }
  ],
  [
   {
    "x": 568.5555555555558,
    "y": 90.67592790391713
   },
   {
    "x": 565.0555555555558,
    "y": 104.67592790391713
   },
   {
    "x": 570.1111111111113,
    "y": 96.89815012613936
   }
  ],
  [
   {
    "x": 569.3333333333335,
    "y": 87.56481679280601
   },
   {
    "x": 569.3333333333335,
    "y": 94.56481679280601
   },
   {
    "x": 571.2777777777779,
    "y": 92.62037234836157
   }
  ],
  [
   {
    "x": 570.888888888889,
    "y": 83.28703901502824
   },
   {
    "x": 570.5000000000002,
    "y": 92.62037234836157
   },
   {
    "x": 572.4444444444446,
    "y": 91.8425945705838
   }
  ],
  [
   {
    "x": 572.0555555555558,
    "y": 83.67592790391713
   },
   {
    "x": 572.4444444444446,
    "y": 88.73148345947268
   },
   {
    "x": 574.7777777777779,
    "y": 86.39815012613934
   }
  ],
  [
   {
    "x": 574.0000000000002,
    "y": 78.62037234836157
   },
   {
    "x": 573.2222222222224,
    "y": 87.9537056816949
   },
   {
    "x": 575.5555555555558,
    "y": 85.62037234836157
   }
  ],
  [
   {
    "x": 576.7222222222224,
    "y": 77.06481679280601
   },
   {
    "x": 574.0000000000002,
    "y": 84.06481679280601
   },
   {
    "x": 576.7222222222224,
    "y": 84.06481679280601
   }
  ],
  [
   {
    "x": 581.0000000000002,
    "y": 74.34259457058378
   },
   {
    "x": 575.5555555555558,
    "y": 82.50926123725046
   },
   {
    "x": 578.6666666666669,
    "y": 82.12037234836157
   }
  ]
 ]
}
